import React, { Component } from "react";
import { calculatePrice } from "../../pricing/calculatePrice";
import Axios from "axios";
import { connect } from "react-redux";
import { configuration } from "../../appConfig";
import Swal from "sweetalert2";
import CarDentLogTable from "../../carbodyparts/CarDentLogTable";
import verticle from "./vertical.json";
import horizontal from "./horizontal.json";
import vertical12Hour from "./vertical12Hour.json";
import horizontal12Hour from "./horizontal12Hour.json";
import { getSelectedPartnerId } from "../../redux/actions/duplicateVinPartnerId";

// import "./DNSPriceTable.css";
import Lightbox from "react-image-lightbox";

import "../dnsReportPrintMode.css";
import "../dnsReport.css";
import "../dnsReportResponsive.css";
import axios from "axios";
import { Spinner } from "reactstrap";
import { reportAuthorized } from "../../redux/actions/reportAuthorized";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

// Axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

const extraPartsArr = [
  "LeftFrontTyre",
  "LeftBackTyre",
  "RightFrontTyre",
  "RightBackTyre",
  "FrontBumper",
  "LeftFrontBumper",
  "LeftBackBumper",
  "RightFrontBumper",
  "RightBackBumper",
  "BackBumper",
  "Underbody",
  "Inside",
];
class DNSPriceTable extends Component {
  state = {
    words: {},
    lang: "En",
    data: [],
    Dents: [],
    ALUPercentage: "",
    LAKPercentage: "",
    GLUPercentage: "",
    softwareType: "",
    loadedFirstTime: true,
    ShowAW: false,
    imageArr: [],
    imageArrDamage: [],
    currentImageIndex: 0,
    filteredImages: [],
    insuaranceProvider: {},
    universal_scan: 0
    // isUpdateBtnLoading : false
  };
  count = [];
  calPrice = (average, count) => {
    let pp = calculatePrice(average, count);
    //this.count.push(pp)
    return (pp * 130) / 6;
  };
  calUnit = (average, count) => {
    let pp = calculatePrice(average, count);
    this.count.push(pp);
    return pp;
  };
  avg = (No) => {
    let round = Math.round(No / 10);
    return round * 10;
  };

  getScanImages = async () => {
    const partnerId = localStorage.getItem("partnerId");
    const selectedFile = localStorage.getItem("selectedFile");
    try {
      const response = await Axios.get(configuration.getScanImages, {
        params: {
          partnerId: partnerId,
          vin: selectedFile,
        },
      });

      if (response && response.data) {
        const { data } = response;
        const filterImages = (images, keyword) => {
          return images ? images.filter(image => image.includes(keyword)) : [];
        };

        const Left = [
          ...filterImages(data.LeftFrontFender || data.Left, "LeftFrontFender"),
          ...filterImages(data.LeftFrontDoor || data.Left, "LeftFrontDoor"),
          ...filterImages(data.LeftBackDoor || data.Left, "LeftBackDoor"),
          ...filterImages(data.LeftBackFender || data.Left, "LeftBackFender")
        ];

        const right = [
          ...filterImages(data.RightFrontFender || data.right, "RightFrontFender"),
          ...filterImages(data.RightFrontDoor || data.right, "RightFrontDoor"),
          ...filterImages(data.RightBackDoor || data.right, "RightBackDoor"),
          ...filterImages(data.RightBackFender || data.right, "RightBackFender")
        ];

        this.setState({
          imageArr: [
            ...data.Hood,
            ...data.Roof,
            ...data.RightRoofFrame,
            ...data.LeftRoofFrame,
            ...data.TrunkCover,
            ...data.Trunk,
            ...right,
            ...Left,


          ],
        });
        const LeftDamage = [
          ...filterImages(data.LeftFrontFender_damage, "LeftFrontFender"),
          ...filterImages(data.LeftFrontDoor_damage, "LeftFrontDoor"),
          ...filterImages(data.LeftBackDoor_damage, "LeftBackDoor"),
          ...filterImages(data.LeftBackFender_damage, "LeftBackFender")
        ];

        const rightDamage = [
          ...filterImages(data.RightFrontFender_damage, "RightFrontFender"),
          ...filterImages(data.RightFrontDoor_damage, "RightFrontDoor"),
          ...filterImages(data.RightBackDoor_damage, "RightBackDoor"),
          ...filterImages(data.RightBackFender_damage, "RightBackFender")
        ];

        this.setState({
          imageArrDamage: [
            ...data.Hood_damage,
            ...data.Roof_damage,
            ...data.RightRoofFrame_damage,
            ...data.LeftRoofFrame_damage,
            ...data.TrunkCover_damage,
            ...data.Trunk_damage,
            ...rightDamage,
            ...LeftDamage,


          ],
        });
      }
    } catch (error) {
      console.error("Error fetching scan images:", error);
    }
  };

  getJsonApi = async () => {
    try {
      const partnerId = localStorage.getItem("partnerId");
      const vin = localStorage.getItem("selectedFile");
      const response = await Axios.get(
        `${configuration.getData}?vin=${vin}&partnerId=${partnerId}`
      );
      const r = response.data;
      if (r) {
        this.props.reportAuthorized({
          Authorized: r.Authorized,
          DATReportAuthorized: r.DATReportAuthorized,
          MiniReportAuthorized: r.MiniReportAuthorized,
          FullReportAuthorized: r.FullReportAuthorized,
          DetailedReportAuthorized: r.DetailedReportAuthorized,
          AmericanReportAuthorized: r.AmericanReportAuthorized,
        });
        if (r.Client) {
          this.getInsurenceClients();
        }
        await this.getFallbackDetails();
        await this.refreshAWCalculation(r.Dents, r);
        this.setState({
          softwareType: r.SoftwareType,
          ShowAW: r.hasOwnProperty("ShowAW") ? r.ShowAW : false,
          Client: r.Client,
        });
        const arrDataAE = {
          Hood: ["Dämmung", "Gitter", "Komplett"],
          LeftFrontFender: ["Scheinwerfer", "Radhaus", "Komplett"],
          RightFrontFender: ["Komplett", "Schachtleiste", "Verkleidung", "Spiegel", "Griff"],
          LeftFrontDoor: ["Komplett", "Schachtleiste", "Verkleidung", "Griff"],
          RightFrontDoor: ["Rücklicht", "Verkleidung", "Radhausschale", "TankEinsatz"],
          LeftBackDoor: ["3. Bremsleuchte", "Heckklappe", "Verkleidung"],
          RightBackDoor: ["3. Bremsleuchte", "Heckklappe", "Verkleidung"],
          LeftBackFender: ["Rücklicht", "Verkleidung", "Radhausschale", "TankEinsatz"],
          RightBackFender: ["Komplett", "Schachtleiste", "Verkleidung", "Griff"],
          Trunk: ["Schachtleiste", "Verkleidung", "Spiegel", "Komplett", "Griff"],
          TrunkCover: ["Schachtleiste", "Radhaus", "Komplett"],
          Roof: ["Dämmung", "Himmel", "Panorama", "Dachantenne"],
          LeftRoofFrame: ["Dachreling"],
          RightRoofFrame: ["Dachreling"],
        };
        if (r.Dents) {
          r.Dents.forEach((dent) => {
            dent.arrAE = arrDataAE[dent.Part];
          });
        }
        const arrDataErsetzenErsetzen = {
          Hood: ["Befestigungssatz", "Embleme", "Motorhaube"],
          LeftFrontFender: ["Befestigungssatz", "Blinker", "Kotflügel"],
          RightFrontFender: ["Tür", "Zierleiste:", "Befestigungssatz", "Spiegel", "Schachtleiste", "Blende:", "Türfolie"],
          LeftFrontDoor: ["Tür", "Zierleiste:", "Befestigungssatz", "Schachtleiste", "Blende:", "Türfolie"],
          RightFrontDoor: ["Rückleuchte", "Seitenscheibe:", "Zierleiste Scheibe"],
          LeftBackDoor: ["3. Bremsleuchte", "Heckklappe", "Leuchte IL", "Leuchte IR", "Befestigungssatz", "Embleme"],
          RightBackDoor: ["3. Bremsleuchte", "Heckklappe", "Leuchte IL", "Leuchte IR", "Befestigungssatz", "Embleme"],
          LeftBackFender: ["Rückleuchte", "Seitenscheibe", "Zierleiste Scheibe"],
          RightBackFender: ["Tür", "Zierleiste:", "Befestigungssatz", "Schachtleiste", "Blende:", "Türfolie"],
          Trunk: ["Tür", "Türfolie", "Spiegel", "Zierleiste:", "Schachtleiste", "Befestigungssatz", "Blende:"],
          TrunkCover: ["Befestigungssatz", "Blinker", "Kotflügel"],
          Roof: ["Himmel", "Dämmung x 0", "Dachantenne", "Handgriff x 0"],
          LeftRoofFrame: ["Kap. Reling x 0", "Dachleiste"],
          RightRoofFrame: ["Kap. Reling x 0", "Dachleiste"],
        };
        if (r.Dents) {
          r.Dents.forEach((dent) => {
            dent.arrErsetzen = arrDataErsetzenErsetzen[dent.Part];
          });
        }
        this.setState(
          {
            data: r,
            Dents: Array.isArray(r.Dents) ? r.Dents : [],
            Authorized: r.Authorized || false,
          },
          () => {
            this.updateOrder();
          }
        );
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  getInsurenceClients = async () => {
    const partnerId = localStorage.getItem("partnerId");

    if (partnerId) {
      const url = configuration.getInsurenceClients + "?partnerId=" + partnerId;
      const response = await axios.post(url)
      if (response.data) {
        response.data.map((info) => {
          if (this.state.Client && this.state.Client != undefined && this.state.Client != "" && this.state.Client.toLocaleLowerCase() == info.Name.toLocaleLowerCase()) {
            this.setState({ insuaranceProvider: info })
          }
        })
      }
    }
  };

  getTotalDiamm = () => {
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    Axios.get(
      `${configuration.getTotalDiamm}?vin=${vin}&partnerId=${partnerId}`
    ).then((r) => {
      // this.getJsonApi()
      if (r.data) {

        // this.refreshAWCalculation(r.data.Dents,r.data)
        // this.setState({
        //   softwareType: r.data.SoftwareType,
        //   ShowAW: r.data.hasOwnProperty("ShowAW") ? r.data.ShowAW : false,
        // });

        // r.data.Dents &&
        //   r.data.Dents.map((dent) => {
        //     dent.arrAE = arrDataAE[dent.Part];
        //   });

        // r.data.Dents &&
        //   r.data.Dents.map((dent) => {
        //     dent.arrErsetzen = arrDataErsetzenErsetzen[dent.Part];
        //   });

        // this.setState(
        //   {
        //     data: r.data,
        //     Dents:
        //       r.data && r.data.Dents && Array.isArray(r.data.Dents)
        //         ? r.data.Dents
        //         : [],
        //     Authorized: r.data && r.data.Authorized ? r.data.Authorized : false,
        //   },
        //   () => {
        //     this.updateOrder();
        //   }
        // );
      }
    });
  };
  componentDidMount() {
    this.getJsonApi();
    // this.getTotalDiamm();
    this.getLang();
    // this.getFallbackDetails();
    this.getScanImages();
  }

  updateOrder = () => {
    const partnerId = localStorage.getItem("partnerId");
    const isApplyOrderSorting = !["16-220515", "6-200406"].includes(partnerId);
    const { Dents } = this.state;
    if (isApplyOrderSorting && Array.isArray(Dents)) {
      const order = [
        "Hood",
        "LeftFrontFender",
        "RightFrontFender",
        "LeftFrontDoor",
        "RightFrontDoor",
        "LeftBackDoor",
        "RightBackDoor",
        "LeftBackFender",
        "RightBackFender",
        "Trunk",
        "TrunkCover",
        "Roof",
        "LeftRoofFrame",
        "RightRoofFrame",
      ];
      const sortedDentsArr = [...Dents];
      sortedDentsArr.sort(function (a, b) {
        return order.indexOf(a.Part) - order.indexOf(b.Part);
      });
      this.setState({
        Dents: sortedDentsArr,
        data: { ...this.state.data, Dents: sortedDentsArr },
      });
    }
  };

  getFallbackDetails = async () => {
    const url =
      configuration.getFallbackDetails +
      `?partner_id=${localStorage.getItem("partnerId")}`;
    const res = await Axios.get(url);
    // Convert hexadecimal color code to RGBA

    // function hexToRgb(hex) {
    //   hex = hex.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => '#' + r + r + g + g + b + b);
    //   let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    //   return result ? {
    //     r: parseInt(result[1], 16),
    //     g: parseInt(result[2], 16),
    //     b: parseInt(result[3], 16)
    //   } : null;
    // }

    // let rgbColor = hexToRgb(res.data.primary_color);
    // let rgbaColor = `rgba(${rgbColor.r}, ${rgbColor.g}, ${rgbColor.b}, 0.20)`;

    function hexToRgb(hex) {
      // Check if the provided hex string is valid
      if (!/^#?([a-f\d]{3}){1,2}$/i.test(hex)) {
        console.error("Invalid hexadecimal color string:", hex);
        return null;
      }

      // Normalize the hex string to a valid 6-digit format if it's in a 3-digit format
      hex = hex.replace(
        /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
        (m, r, g, b) => "#" + r + r + g + g + b + b
      );

      // Extract RGB values
      let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

      // If the result is not null, return an object with RGB values
      if (result) {
        return {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16),
        };
      } else {
        console.error("Failed to convert hexadecimal color to RGB:", hex);
        return null;
      }
    }

    let primaryColor = res && res.data && res.data.primary_color;
    let rgbaColor;

    if (primaryColor) {
      let rgbColor = hexToRgb(this.state.insuaranceProvider.PrimaryColor || primaryColor);
      if (rgbColor) {
        rgbaColor = `rgba(${rgbColor.r}, ${rgbColor.g}, ${rgbColor.b}, 0.20)`;
      }
    }

    // Create a <style> element and append it to the document head
    if (res.data.success !== false) {
      this.props.getSelectedPartnerId({
        duplicateSelectedPartnerId: res.data.vin_duplicate_partner_id.length > 0 ? res.data.vin_duplicate_partner_id : [],
        isDuplicateVin: res.data.is_vin_duplicate
      })
      this.setState({
        ALUPercentage: res.data.alu,
        LAKPercentage: res.data.lak,
        GLUPercentage: res.data.glu,
        PrimaryColor: res.data.primary_color || "#FF0000",
        SecondaryColor: res.data.secondary_color || "#000000",
        PrimaryTextColor: res.data.primary_text_color || "#000000",
        SecondaryTextColor: res.data.secondary_text_color || "#fff",
        rgbaColor: rgbaColor,
        universal_scan: res.data.is_universal_scan
      });
    }
  };

  getLang = () => {
    const base_url = window.location.origin;
    Axios.get(`${base_url}/lang.json`).then((res) => {
      this.setState({ words: res.data, lang: localStorage.getItem("lang") });
    });
  };
  lang = (word) => {
    const { lang, words } = this.state;

    return words[word] ? words[word][lang] : word;
  };
  componentWillReceiveProps(nextProps, prevState) {
    if (nextProps.Authorized !== prevState.Authorized) {
      this.setState({
        Authorized: nextProps.Authorized,
      });
    }
    if (nextProps.lang !== prevState.lang) {
      this.setState({ lang: nextProps.lang });
    } else {
      return;
    }
  }

  saveChanges = (payload) => {
    const { data } = this.state;
    const totalDents = this.getTotalDents();
    payload["TotalDentCount"] = totalDents;
    payload.IsPriceTableUpdated = true;
    const url =
      configuration.PostEditorChanges +
      `?partnerId=${localStorage.getItem(
        "partnerId"
      )}&vin=${localStorage.getItem(
        "selectedFile"
      )}&dents=${totalDents}&TabViewUpdated=${!data.TabViewUpdated}`;

    Axios.post(url, payload).then((res) => {
      Toast.fire({
        type: "success",
        title: "Data saved successfully",
      });
      // window.location.reload();
    });
  };

  changeAE = (event, index, value, key) => {
    const { Dents, data } = this.state;
    const totalDents = Dents[index].TotalDents;
    const aeArr = Array.isArray(Dents[index]["AE"]) ? Dents[index]["AE"] : [];

    if (event.target.checked) {
      // if (key === "AE") {
      aeArr.push(`${value}`);
      // Dents[index]["AE"] = [];
      // }
    } else {
      aeArr.map((val, idx) => {
        if (value == val) {
          aeArr.splice(idx, 1);
        }
      });
    }

    Dents[index]["AE"] = aeArr;
    // Dents[index]["AE"] = [];
    this.setState({ data });
    // this.saveChanges(data, totalDents);
  };

  changeErsetzen = (event, index, value, key) => {
    const { Dents, data } = this.state;
    const totalDents = Dents[index].TotalDents;
    const ersetzenArr = Array.isArray(Dents[index]["Ersetzen"])
      ? Dents[index]["Ersetzen"]
      : [];

    if (event.target.checked) {
      // if (key === "Ersetzen") {
      ersetzenArr.push(`${value}`);
      // Dents[index]["Ersetzen"] = [];
      // }
    } else {
      ersetzenArr.map((val, indx) => {
        if (value == val) {
          ersetzenArr.splice(indx, 1);
        }
      });
    }

    Dents[index]["Ersetzen"] = ersetzenArr;
    if (
      ersetzenArr.length &&
      (Dents[index].Replace === false || Dents[index].Replace === "")
    ) {
      this.change("", event, index, "Replace");
    } else if (ersetzenArr.length === 0 && Dents[index].Replace === true) {
      this.change("", event, index, "Replace");
    }
    // Dents[index]["Ersetzen"] = [];
    this.setState({ data });
    // this.saveChanges(data, totalDents);
  };

  decimalAdjust = (type, value, exp) => {
    // If the exp is undefined or zero...
    if (typeof exp === "undefined" || +exp === 0) {
      return Math[type](value);
    }
    value = +value;
    exp = +exp;
    // If the value is not a number or the exp is not an integer...
    if (isNaN(value) || !(typeof exp === "number" && exp % 1 === 0)) {
      return NaN;
    }
    // Shift
    value = value.toString().split("e");
    value = Math[type](+(value[0] + "e" + (value[1] ? +value[1] - exp : -exp)));
    // Shift back
    value = value.toString().split("e");
    return +(value[0] + "e" + (value[1] ? +value[1] + exp : exp));
  };

  round10 = (value, exp) => this.decimalAdjust("round", value, exp);

  change = (part, e, index, key) => {
    const { Dents, data } = this.state;
    const totalDents = Dents[index].TotalDents;

    if (key === "Replace") {
      if (Dents[index][key]) {
        Dents[index]["AW"] = Dents[index]["OriginalAw"] || 0;
        // }
      } else {
        Dents[index]["Alu"] = false;
        Dents[index]["Push2paint"] = false;
        Dents[index]["Glue"] = false;
        Dents[index]["AW"] = 0;

      }
    } else {
      Dents[index][key] = e.target.checked;
      if (Dents[index]["Replace"]) {
        Dents[index]["Replace"] = false;
        Dents[index]["Ersetzen"] = [];
        if (
          localStorage.getItem("client") === "DNS" ||
          localStorage.getItem("client") === "AUS"
        ) {
          Dents[index]["AW"] = Dents[index]["AW_original"] || 0;
        }
      }
      const { ALUPercentage, LAKPercentage, GLUPercentage } = this.state;

      let aluPr = parseFloat(ALUPercentage);
      let lakPr = parseFloat(LAKPercentage);
      let gluPr = parseFloat(GLUPercentage);

      let incPR = 0;

      if (Dents[index].Alu && Dents[index].Push2paint && Dents[index].Glue) {
        incPR = aluPr + lakPr + gluPr;
      } else if (Dents[index].Alu && Dents[index].Push2paint) {
        incPR = aluPr + lakPr;
      } else if (Dents[index].Alu && Dents[index].Glue) {
        incPR = aluPr + gluPr;
      } else if (Dents[index].Push2paint && Dents[index].Glue) {
        incPR = lakPr + gluPr;
      } else if (Dents[index].Alu) {
        incPR = aluPr;
      } else if (Dents[index].Push2paint) {
        incPR = lakPr;
      } else if (Dents[index].Glue) {
        incPR = gluPr;
      }

      if (Dents[index]["OriginalAw"]) {
        // if (localStorage.getItem('partnerId') === "1-190301"){

        Dents[index]["AW"] =
          0 ||
          Math.ceil(
            parseFloat(Dents[index]["OriginalAw"]) +
            (parseFloat(Dents[index]["OriginalAw"]) * incPR) / 100.0
          );
        // }
      } else {
        // if (localStorage.getItem('partnerId') === "1-190301"){
        Dents[index]["AW"] =
          0 ||
          Math.ceil(
            parseFloat(Dents[index]["AW"]) +
            (parseFloat(Dents[index]["AW"]) * incPR) / 100.0
          );
        // }
      }

    }
    Dents[index][key] = e.target.checked;

    this.setState({ data });
  };

  plasticChange = (part, e, index, key) => {
    const { name } = e.target;
    const { Dents, data } = this.state;
    if (e.target.checked) {
      data["Dents"][index]["AvgDiaMm"] = 0;
      data["Dents"][index]["TotalDents"] = 0;
    } else {
      data["Dents"][index]["AvgDiaMm"] = data["Dents"][index]["B"];
      data["Dents"][index]["TotalDents"] = data["Dents"][index]["A"];
    }
    data["Dents"][index][key] = e.target.checked;
    this.setState({ data })
    // , () => {this.handleSave()});
  };
  totalDamages = (arr) => {
    let total = 0;
    arr.forEach((el) => {
      if (el.TotalDamages) {
        total = total + el.TotalDamages;
      }
    });
    return total;
  };

  totalDamageCounts = (arr) => {
    let total = 0;
    arr.map((el) => {
      if (
        el.Part !== "LeftFrontTyre" &&
        el.Part !== "LeftBackTyre" &&
        el.Part !== "RightFrontTyre" &&
        el.Part !== "RightBackTyre" &&
        el.Part !== "FrontBumper" &&
        el.Part !== "LeftFrontBumper" &&
        el.Part !== "LeftBackBumper" &&
        el.Part !== "RightFrontBumper" &&
        el.Part !== "RightBackBumper" &&
        el.Part !== "BackBumper" &&
        el.Part !== "Underbody" &&
        el.Part !== "Inside"
      ) {
        if (el.DamageCount) {
          total = total + el.DamageCount;
        }
      }
    });
    return total;
  };

  handleNotesChange = (e) => {
    // const {data} = this.state
    this.setState({
      data: { ...this.state.data, [e.target.name]: e.target.value }
    })
  }

  refreshAWCalculation = (dents, data) => {
    dents && dents.length > 0 && dents.map((parts, i) => {

      if (parts["B"] == 10) {
        parts["B"] = 20
      }
      if (parts["AvgDiaMm"] == 10) {
        parts["AvgDiaMm"] = 20
      }

      const makeLowerCase = data.Make.toLowerCase(); // Convert data.Make to lowercase
      const makeList = ["bmw", "daimler", "chrysler", "smart", "mini", "pontiac"]; // List in lowercase

      this.setState({ loadedFirstTime: false });
      parts[parts.Part] = Math.abs(parts.A ? parseInt(parts.A) : 0);
      parts["A"] = Math.abs(parts.A ? parseInt(parts.A) : 0);

      let filtered;
      let maxVerticle;
      let maxHorizontal;
      let max12HourVerticle;
      let max12HourHorizontal;

      if (
        // partnerId == "demo-de" &&
        makeList.includes(makeLowerCase) // Case-insensitive match
      ) {
        if (parts.Part == "Hood" || parts.Part == "TrunkCover" || parts.Part == "Roof" || parts.Part == "RightRoofFrame" || parts.Part == "LeftRoofFrame") {
          if (parts["A"] > 800) {
            max12HourHorizontal = true;
          } else {
            max12HourHorizontal = false;
            filtered = horizontal12Hour.filter((item) => {
              return item.A === parts["A"];
            });
          }
        } else {
          if (parts["A"] > 100) {
            max12HourVerticle = true;
          } else {
            max12HourVerticle = false;
            filtered = vertical12Hour.filter((item) => {
              return item.A === parts["A"];
            });
            if (!filtered.length) {
              filtered[0] = vertical12Hour.reduce((prev, curr) => {
                return Math.abs(curr.A - parts["A"]) <
                  Math.abs(prev.A - parts["A"])
                  ? curr
                  : prev;
              });
            }
          }
        }
        if (
          localStorage.getItem("client") === "DNS" ||
          localStorage.getItem("client") === "AUS"
        ) {
          if (max12HourHorizontal) {
            parts["AW"] = horizontal12Hour[horizontal12Hour.length - 1][
              `B${parts["AvgDiaMm"]}`
            ]
              ? horizontal12Hour[horizontal12Hour.length - 1][
              `B${parts["AvgDiaMm"]}`
              ]
              : 0;
            parts["OriginalAw"] = parts["AW"];
          } else if (max12HourVerticle) {
            parts["AW"] = vertical12Hour[vertical12Hour.length - 1][
              `B${parts["AvgDiaMm"]}`
            ]
              ? vertical12Hour[vertical12Hour.length - 1][
              `B${parts["AvgDiaMm"]}`
              ]
              : 0;
            parts["OriginalAw"] = parts["AW"];
          } else {
            parts["AW"] = filtered[0][`B${parts["AvgDiaMm"]}`]
              ? filtered[0][`B${parts["AvgDiaMm"]}`]
              : 0;
            parts["OriginalAw"] = parts["AW"];
          }
        }
      } else {
        if (parts.Part == "Hood" || parts.Part == "TrunkCover" || parts.Part == "Roof" || parts.Part == "RightRoofFrame" || parts.Part == "LeftRoofFrame") {
          if (parts["A"] > 800) {
            maxHorizontal = true;
          } else {
            maxHorizontal = false;
            filtered = horizontal.filter((item) => {
              return item.A === parts["A"];
            });
          }
        } else {
          if (parts["A"] > 130) {
            maxVerticle = true;
          } else {
            maxVerticle = false;
            filtered = verticle.filter((item) => {
              return item.A === parts["A"];
            });
            if (!filtered.length) {
              filtered[0] = verticle.reduce((prev, curr) => {
                return Math.abs(curr.A - parts["A"]) <
                  Math.abs(prev.A - parts["A"])
                  ? curr
                  : prev;
              });
            }
          }
        }
        if (
          localStorage.getItem("client") === "DNS" ||
          localStorage.getItem("client") === "AUS"
        ) {
          if (maxHorizontal) {
            parts["AW"] = horizontal[horizontal.length - 1][
              `B${parts["AvgDiaMm"]}`
            ]
              ? horizontal[horizontal.length - 1][`B${parts["AvgDiaMm"]}`]
              : 0;
            parts["OriginalAw"] = parts["AW"];
          } else if (maxVerticle) {
            parts["AW"] = verticle[verticle.length - 1][
              `B${parts["AvgDiaMm"]}`
            ]
              ? verticle[verticle.length - 1][
              `B${parts["AvgDiaMm"]}`
              ]
              : 0;
            parts["OriginalAw"] = parts["AW"];
          } else {
            if (filtered.length > 0) {
              parts["AW"] = filtered[0][`B${parts["AvgDiaMm"]}`]
                ? filtered[0][`B${parts["AvgDiaMm"]}`]
                : 0;
              parts["OriginalAw"] = parts["AW"];
            }
          }
        }
      }

      const deviation = parts.A - parts["OriginalDents"];
      if (deviation > 0) {
        parts["AddedCount"] = deviation;
        parts["RemovedCount"] = 0;
      } else {
        parts["RemovedCount"] = Math.abs(deviation);
        parts["AddedCount"] = 0;
      }

      if (parts.PaintCount > 0 && this.state.universal_scan == '1') {
        parts["Push2paint"] = true
      }

      const { ALUPercentage, LAKPercentage, GLUPercentage } = this.state;

      let aluPr = parseFloat(ALUPercentage);
      let lakPr = parseFloat(LAKPercentage);
      let gluPr = parseFloat(GLUPercentage);

      let incPR = 0;

      if (parts.Alu && parts.Push2paint && parts.Glue) {
        incPR = aluPr + lakPr + gluPr;
      } else if (parts.Alu && parts.Push2paint) {
        incPR = aluPr + lakPr;
      } else if (parts.Alu && parts.Glue) {
        incPR = aluPr + gluPr;
      } else if (parts.Push2paint && parts.Glue) {
        incPR = lakPr + gluPr;
      } else if (parts.Alu) {
        incPR = aluPr;
      } else if (parts.Push2paint) {
        incPR = lakPr;
      } else if (parts.Glue) {
        incPR = gluPr;
      }

      if (parts.OriginalAw) {
        parts.AW =
          0 ||
          Math.ceil(
            parseFloat(parts.OriginalAw) +
            (parseFloat(parts.OriginalAw) * incPR) / 100.0
          );
      } else {
        parts.AW =
          0 ||
          Math.ceil(
            parseFloat(parts.AW) +
            (parseFloat(parts.AW) * incPR) / 100.0
          );
      }

    })
  }

  handleChange = (part, index, e) => {
    const { Dents, data } = this.state;
    const { name, value } = e.target;
    // let value = e.target.value == 10 ? 20 : e.target.value

    const partnerId = localStorage.getItem("partnerId");
    const makeLowerCase = data.Make.toLowerCase(); // Convert data.Make to lowercase
    const makeList = ["bmw", "daimler", "chrysler", "smart", "mini", "pontiac"]; // List in lowercase

    if (name === "TotalDents") {
      this.setState({ loadedFirstTime: false });
      Dents[index][name] = Math.abs(value ? parseInt(value) : 0);
      Dents[index]["A"] = Math.abs(value ? parseInt(value) : 0);

      let filtered;
      let maxVerticle;
      let maxHorizontal;
      let max12HourVerticle;
      let max12HourHorizontal;

      if (
        // partnerId == "demo-de" &&
        makeList.includes(makeLowerCase) // Case-insensitive match
      ) {
        if (part == "Hood" || part == "TrunkCover" || part == "Roof" || part == "RightRoofFrame" || part == "LeftRoofFrame") {
          if (Dents[index]["A"] > 800) {
            max12HourHorizontal = true;
          } else {
            max12HourHorizontal = false;
            filtered = horizontal12Hour.filter((item) => {
              return item.A === Dents[index]["A"];
            });
          }
        } else {
          if (Dents[index]["A"] > 100) {
            max12HourVerticle = true;
          } else {
            max12HourVerticle = false;
            filtered = vertical12Hour.filter((item) => {
              return item.A === Dents[index]["A"];
            });
            if (!filtered.length) {
              filtered[0] = vertical12Hour.reduce((prev, curr) => {
                return Math.abs(curr.A - Dents[index]["A"]) <
                  Math.abs(prev.A - Dents[index]["A"])
                  ? curr
                  : prev;
              });
            }
          }
        }
        if (
          localStorage.getItem("client") === "DNS" ||
          localStorage.getItem("client") === "AUS"
        ) {
          if (max12HourHorizontal) {
            Dents[index]["AW"] = horizontal12Hour[horizontal12Hour.length - 1][
              `B${Dents[index]["AvgDiaMm"]}`
            ]
              ? horizontal12Hour[horizontal12Hour.length - 1][
              `B${Dents[index]["AvgDiaMm"]}`
              ]
              : 0;
            Dents[index]["OriginalAw"] = Dents[index]["AW"];
          } else if (max12HourVerticle) {
            Dents[index]["AW"] = vertical12Hour[vertical12Hour.length - 1][
              `B${Dents[index]["AvgDiaMm"]}`
            ]
              ? vertical12Hour[vertical12Hour.length - 1][
              `B${Dents[index]["AvgDiaMm"]}`
              ]
              : 0;
            Dents[index]["OriginalAw"] = Dents[index]["AW"];
          } else {
            Dents[index]["AW"] = filtered[0][`B${Dents[index]["AvgDiaMm"]}`]
              ? filtered[0][`B${Dents[index]["AvgDiaMm"]}`]
              : 0;
            Dents[index]["OriginalAw"] = Dents[index]["AW"];
          }
        }
      } else {
        if (part == "Hood" || part == "TrunkCover" || part == "Roof" || part == "RightRoofFrame" || part == "LeftRoofFrame") {
          if (Dents[index]["A"] > 800) {
            maxHorizontal = true;
          } else {
            maxHorizontal = false;
            filtered = horizontal.filter((item) => {
              return item.A === Dents[index]["A"];
            });
          }
        } else {
          if (Dents[index]["A"] > 130) {
            maxVerticle = true;
          } else {
            maxVerticle = false;
            filtered = verticle.filter((item) => {
              return item.A === Dents[index]["A"];
            });
            if (!filtered.length) {
              filtered[0] = verticle.reduce((prev, curr) => {
                return Math.abs(curr.A - Dents[index]["A"]) <
                  Math.abs(prev.A - Dents[index]["A"])
                  ? curr
                  : prev;
              });
            }
          }
        }
        if (
          localStorage.getItem("client") === "DNS" ||
          localStorage.getItem("client") === "AUS"
        ) {
          if (maxHorizontal) {
            Dents[index]["AW"] = horizontal[horizontal.length - 1][
              `B${Dents[index]["AvgDiaMm"]}`
            ]
              ? horizontal[horizontal.length - 1][`B${Dents[index]["AvgDiaMm"]}`]
              : 0;
            Dents[index]["OriginalAw"] = Dents[index]["AW"];
          } else if (maxVerticle) {
            Dents[index]["AW"] = verticle[verticle.length - 1][
              `B${Dents[index]["AvgDiaMm"]}`
            ]
              ? verticle[verticle.length - 1][
              `B${Dents[index]["AvgDiaMm"]}`
              ]
              : 0;
            Dents[index]["OriginalAw"] = Dents[index]["AW"];
          } else {
            if (filtered.length > 0) {
              Dents[index]["AW"] = filtered[0][`B${Dents[index]["AvgDiaMm"]}`]
                ? filtered[0][`B${Dents[index]["AvgDiaMm"]}`]
                : 0;
              Dents[index]["OriginalAw"] = Dents[index]["AW"];
            }
          }
        }
      }

      const deviation = value - Dents[index]["OriginalDents"];
      if (deviation > 0) {
        Dents[index]["AddedCount"] = deviation;
        Dents[index]["RemovedCount"] = 0;
      } else {
        Dents[index]["RemovedCount"] = Math.abs(deviation);
        Dents[index]["AddedCount"] = 0;
      }
    } else if (name === "AvgDiaMm") {
      Dents[index]["AvgDiaMm"] = value ? parseInt(value) : 0;
      Dents[index]["B"] = value ? parseInt(value) : 0;

      let filtered;
      let maxVerticle;
      let maxHorizontal;
      let max12HourVerticle;
      let max12HourHorizontal;

      if (
        // partnerId == "demo-de" &&
        makeList.includes(makeLowerCase) // Case-insensitive match
      ) {
        if (part == "Hood" || part == "TrunkCover" || part == "Roof" || part == "RightRoofFrame" || part == "LeftRoofFrame") {
          if (Dents[index]["A"] > 800) {
            max12HourVerticle = true;
          } else {
            max12HourVerticle = false;
            filtered = horizontal12Hour.filter((item) => {
              return item.A === Dents[index]["A"];
            });
          }
        } else {
          if (Dents[index]["A"] > 100) {
            max12HourVerticle = true;
          } else {
            max12HourVerticle = false;
            filtered = vertical12Hour.filter((item) => {
              return item.A === Dents[index]["A"];
            });
            if (!filtered.length) {
              filtered[0] = vertical12Hour.reduce((prev, curr) => {
                return Math.abs(curr.A - Dents[index]["A"]) <
                  Math.abs(prev.A - Dents[index]["A"])
                  ? curr
                  : prev;
              });
            }
          }
        }
        if (
          localStorage.getItem("client") === "DNS" ||
          localStorage.getItem("client") === "AUS"
        ) {
          if (max12HourVerticle) {
            Dents[index]["AW"] = horizontal12Hour[horizontal12Hour.length - 1][
              `B${Dents[index]["AvgDiaMm"]}`
            ]
              ? horizontal12Hour[horizontal12Hour.length - 1][
              `B${Dents[index]["AvgDiaMm"]}`
              ]
              : 0;
            Dents[index]["OriginalAw"] = Dents[index]["AW"];
          } else if (max12HourVerticle) {
            Dents[index]["AW"] = vertical12Hour[vertical12Hour.length - 1][
              `B${Dents[index]["AvgDiaMm"]}`
            ]
              ? vertical12Hour[vertical12Hour.length - 1][
              `B${Dents[index]["AvgDiaMm"]}`
              ]
              : 0;
            Dents[index]["OriginalAw"] = Dents[index]["AW"];
          } else {
            Dents[index]["AW"] = filtered[0][`B${Dents[index]["AvgDiaMm"]}`]
              ? filtered[0][`B${Dents[index]["AvgDiaMm"]}`]
              : 0;
            Dents[index]["OriginalAw"] = Dents[index]["AW"];
          }
        }
      } else {
        if (part == "Hood" || part == "TrunkCover" || part == "Roof" || part == "RightRoofFrame" || part == "LeftRoofFrame") {
          if (Dents[index]["A"] > 800) {
            maxHorizontal = true;
          } else {
            maxHorizontal = false;
            filtered = horizontal.filter((item) => {
              return item.A === Dents[index]["A"];
            });
          }
        } else {
          if (Dents[index]["A"] > 130) {
            maxVerticle = true;
          } else {
            maxVerticle = false;
            filtered = verticle.filter((item) => {
              return item.A === Dents[index]["A"];
            });
            if (!filtered.length) {
              filtered[0] = verticle.reduce((prev, curr) => {
                return Math.abs(curr.A - Dents[index]["A"]) <
                  Math.abs(prev.A - Dents[index]["A"])
                  ? curr
                  : prev;
              });
            }
          }
        }
        if (
          localStorage.getItem("client") === "DNS" ||
          localStorage.getItem("client") === "AUS"
        ) {
          if (maxHorizontal) {
            Dents[index]["AW"] = horizontal[horizontal.length - 1][
              `B${Dents[index]["AvgDiaMm"]}`
            ]
              ? horizontal[horizontal.length - 1][`B${Dents[index]["AvgDiaMm"]}`]
              : 0;
            Dents[index]["OriginalAw"] = Dents[index]["AW"];
          } else if (maxVerticle) {
            Dents[index]["AW"] = verticle[verticle.length - 1][
              `B${Dents[index]["AvgDiaMm"]}`
            ]
              ? verticle[verticle.length - 1][
              `B${Dents[index]["AvgDiaMm"]}`
              ]
              : 0;
            Dents[index]["OriginalAw"] = Dents[index]["AW"];
          } else {
            Dents[index]["AW"] = filtered[0][`B${Dents[index]["AvgDiaMm"]}`]
              ? filtered[0][`B${Dents[index]["AvgDiaMm"]}`]
              : 0;
            Dents[index]["OriginalAw"] = Dents[index]["AW"];
          }
        }
      }
    } else if (name === "AW") {
      if (
        localStorage.getItem("client") === "DNS" ||
        localStorage.getItem("client") === "AUS"
      ) {
        Dents[index]["AW"] = value ? parseInt(value) : 0;
        Dents[index]["C"] = value ? parseInt(value) : 0;
      }
    }

    this.setState({ data });
  };

  handleInputChange = (e, row, index) => {
    const { value } = e.target
    const inputValue = parseInt(value);
    if (!row.Plastic && inputValue >= 0) {
      let newValue = row.AvgDiaMm;

      if (inputValue > row.AvgDiaMm) {
        // Increment
        if (row.AvgDiaMm === 0) {
          newValue = 20;
        } else {
          newValue = row.AvgDiaMm + 10;
        }
      } else if (inputValue < row.AvgDiaMm) {
        // Decrement
        if (row.AvgDiaMm === 20) {
          newValue = 0;
        } else {
          newValue = row.AvgDiaMm - 10;
        }
      }
      this.handleChange(row.Part, index, { target: { name: "AvgDiaMm", value: newValue } });
    }
  };

  handleSave = () => {
    // this.setState({ isUpdateBtnLoading : true})
    const { data, ShowAW } = this.state;
    data["TotalDentCount"] = this.getTotalDents();
    data && data.Dents && data.Dents.forEach((part) => {
      part.B = part.B ? this.round10(parseInt(part.B), 1) : 0;
      part.AvgDiaMm = part.B ? this.round10(parseInt(part.AvgDiaMm), 1) : 0;
      if (part.Plastic) {
        part.TotalDamages = 0;
        part.AvgDiaMm = 0;
        part.TotalDents = 0;
        part.A = 0;
        part.B = 0;
        part.C = 0;
        part.AddedCount = 0;
        part.OriginalAw = 0;
        part.AW = 0;

        part.Alu = false;
        part.Push2paint = false;
        part.Glue = false;
      }
    });
    this.setState({ data });
    const url =
      configuration.PostEditorChanges +
      `?partnerId=${localStorage.getItem(
        "partnerId"
      )}&vin=${localStorage.getItem(
        "selectedFile"
      )}&TabViewUpdated=${!data.TabViewUpdated}`;

    Axios.post(url, {
      ...data, ShowAW, IsPriceTableUpdated: true, PartnerID: localStorage.getItem(
        "partnerId"
      )
    }).then((res) => {
      Toast.fire({
        type: "success",
        title: "Data saved successfully",
      });
      // this.setState({isUpdateBtnLoading : false})
      this.getScanImages()
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    });
  };

  getTotalDents = () => {
    const { Dents } = this.state;
    let totalDents =
      Dents &&
      Dents.reduce((acc, num) => parseInt(acc) + parseInt(num.TotalDents), 0);
    return totalDents;
  };

  // toggle = (partName, showImg) => {
  //   if (showImg) {
  //     this.setState({
  //       modal: !this.state.modal,
  //       imgPartName: partName,
  //     });
  //   } else {
  //     this.setState({
  //       modal: !this.state.modal,
  //     });
  //   }
  // };
  // toggle = (partName, showImg, isPlastic) => {
  //   if (showImg) {
  //     const imageArr = this.state.imageArr && this.state.imageArr.length > 0 && this.state.imageArr.filter((image) => {
  //       const spiltUrl = image.split("/")[6];
  //       const part = isPlastic
  //         ? spiltUrl && spiltUrl.split("_")[0]
  //         : spiltUrl && spiltUrl.split("_")[1];
  //       return part === partName;
  //     });
  //     this.setState({
  //       modal: !this.state.modal,
  //       imgPartName: partName,
  //       currentImageIndex: 0,
  //       filteredImages: imageArr, 
  //     });
  //   } else {
  //     this.setState({
  //       modal: !this.state.modal,
  //     });
  //   }
  // };

  toggle = (partName, showImg, isPlastic) => {
    if (showImg) {
      const images = (configuration.imagePath == "https://backend.drivenscan.live" && this.props.toggleReportDamageImage) ? this.state.imageArrDamage : this.state.imageArr;
      const imageArr = images && images.length > 0 && images.filter((image) => {
        const spiltUrl = image.split("/")[(configuration.imagePath == "https://backend.drivenscan.live" && this.props.toggleReportDamageImage) ? 7 : 6];
        const reportInclude = spiltUrl && spiltUrl.includes("Report")
        const part = reportInclude ? spiltUrl && spiltUrl.split("_")[1] : spiltUrl && spiltUrl.split("_")[0];
        return part === partName;
      });
      console.log(imageArr);
      this.setState({
        modal: !this.state.modal,
        imgPartName: partName,
        currentImageIndex: 0,
        filteredImages: imageArr,
      });
    } else {
      this.setState({
        modal: !this.state.modal,
      });
    }
  };

  ShowAW = (e) => {
    this.setState(
      {
        ShowAW: e.target.checked,
      },
      () => this.handleSave()
    );
  };

  handleDentsChange = (row, index, e, Key, i) => {
    const { Dents } = this.state;
    const newValue = parseFloat(e.target.value);
    const currentValue = Dents[index]["DentsFromSize"][i].Key || 0;
    const updatedValue = currentValue + newValue;

    Dents[index]["DentsFromSize"][i][Key] = updatedValue;
    this.setState({
      Dents,
    });
  };

  getTotalDents10mm = () => {
    const { Dents } = this.state;
    var totalDentCount0mm10mm = 0;
    for (var i = 0; i < Dents && Dents.length; i++) {
      var partData = Dents[i];
      if (
        partData.Part !== "LeftFrontTyre" &&
        partData.Part !== "LeftBackTyre" &&
        partData.Part !== "RightFrontTyre" &&
        partData.Part !== "RightBackTyre" &&
        partData.Part !== "FrontBumper" &&
        partData.Part !== "LeftFrontBumper" &&
        partData.Part !== "LeftBackBumper" &&
        partData.Part !== "RightFrontBumper" &&
        partData.Part !== "RightBackBumper" &&
        partData.Part !== "BackBumper" &&
        partData.Part !== "Underbody" &&
        partData.Part !== "Inside"
      ) {
        var dentCount0mm10mm =
          (partData.DentsFromSize &&
            partData.DentsFromSize[0].DentCount0mm10mm) ||
          0;
        totalDentCount0mm10mm += dentCount0mm10mm;
      }
    }
    return totalDentCount0mm10mm;
  };
  getTotalDents20mm = () => {
    const { Dents } = this.state;
    var totalDentCount10mm20mm = 0;
    for (var i = 0; i < Dents && Dents.length; i++) {
      var partData = Dents[i];
      if (
        partData.Part !== "LeftFrontTyre" &&
        partData.Part !== "LeftBackTyre" &&
        partData.Part !== "RightFrontTyre" &&
        partData.Part !== "RightBackTyre" &&
        partData.Part !== "FrontBumper" &&
        partData.Part !== "LeftFrontBumper" &&
        partData.Part !== "LeftBackBumper" &&
        partData.Part !== "RightFrontBumper" &&
        partData.Part !== "RightBackBumper" &&
        partData.Part !== "BackBumper" &&
        partData.Part !== "Underbody" &&
        partData.Part !== "Inside"
      ) {
        var dentCount10mm20mm =
          (partData.DentsFromSize &&
            partData.DentsFromSize[1].DentCount10mm20mm) ||
          0;
        totalDentCount10mm20mm += dentCount10mm20mm;
      }
    }
    return totalDentCount10mm20mm;
  };
  getTotalDents30mm = () => {
    const { Dents } = this.state;
    var totalDentCount20mm30mm = 0;
    for (var i = 0; i < Dents && Dents.length; i++) {
      var partData = Dents[i];
      if (
        partData.Part !== "LeftFrontTyre" &&
        partData.Part !== "LeftBackTyre" &&
        partData.Part !== "RightFrontTyre" &&
        partData.Part !== "RightBackTyre" &&
        partData.Part !== "FrontBumper" &&
        partData.Part !== "LeftFrontBumper" &&
        partData.Part !== "LeftBackBumper" &&
        partData.Part !== "RightFrontBumper" &&
        partData.Part !== "RightBackBumper" &&
        partData.Part !== "BackBumper" &&
        partData.Part !== "Underbody" &&
        partData.Part !== "Inside"
      ) {
        var dentCount20mm30mm =
          (partData.DentsFromSize &&
            partData.DentsFromSize[2].DentCount20mm30mm) ||
          0;
        totalDentCount20mm30mm += dentCount20mm30mm;
      }
    }
    return totalDentCount20mm30mm;
  };
  getTotalDents40mm = () => {
    const { Dents } = this.state;
    var totalDentCount30mm40mm = 0;
    for (var i = 0; i < Dents && Dents.length; i++) {
      var partData = Dents[i];
      if (
        partData.Part !== "LeftFrontTyre" &&
        partData.Part !== "LeftBackTyre" &&
        partData.Part !== "RightFrontTyre" &&
        partData.Part !== "RightBackTyre" &&
        partData.Part !== "FrontBumper" &&
        partData.Part !== "LeftFrontBumper" &&
        partData.Part !== "LeftBackBumper" &&
        partData.Part !== "RightFrontBumper" &&
        partData.Part !== "RightBackBumper" &&
        partData.Part !== "BackBumper" &&
        partData.Part !== "Underbody" &&
        partData.Part !== "Inside"
      ) {
        var dentCount30mm40mm =
          (partData.DentsFromSize &&
            partData.DentsFromSize[3].DentCount30mm40mm) ||
          0;
        totalDentCount30mm40mm += dentCount30mm40mm;
      }
    }
    return totalDentCount30mm40mm;
  };
  getTotalDents50mm = () => {
    const { Dents } = this.state;
    var totalDentCount40mm50mm = 0;
    for (var i = 0; i < Dents && Dents.length; i++) {
      var partData = Dents[i];
      if (
        partData.Part !== "LeftFrontTyre" &&
        partData.Part !== "LeftBackTyre" &&
        partData.Part !== "RightFrontTyre" &&
        partData.Part !== "RightBackTyre" &&
        partData.Part !== "FrontBumper" &&
        partData.Part !== "LeftFrontBumper" &&
        partData.Part !== "LeftBackBumper" &&
        partData.Part !== "RightFrontBumper" &&
        partData.Part !== "RightBackBumper" &&
        partData.Part !== "BackBumper" &&
        partData.Part !== "Underbody" &&
        partData.Part !== "Inside"
      ) {
        var dentCount40mm50mm =
          (partData.DentsFromSize &&
            partData.DentsFromSize[4].DentCount40mm50mm) ||
          0;
        totalDentCount40mm50mm += dentCount40mm50mm;
      }
    }
    return totalDentCount40mm50mm;
  };
  getTotalDents60mm = () => {
    const { Dents } = this.state;
    var totalDentCount50mm60mm = 0;
    for (var i = 0; i < Dents && Dents.length; i++) {
      var partData = Dents[i];
      if (
        partData.Part !== "LeftFrontTyre" &&
        partData.Part !== "LeftBackTyre" &&
        partData.Part !== "RightFrontTyre" &&
        partData.Part !== "RightBackTyre" &&
        partData.Part !== "FrontBumper" &&
        partData.Part !== "LeftFrontBumper" &&
        partData.Part !== "LeftBackBumper" &&
        partData.Part !== "RightFrontBumper" &&
        partData.Part !== "RightBackBumper" &&
        partData.Part !== "BackBumper" &&
        partData.Part !== "Underbody" &&
        partData.Part !== "Inside"
      ) {
        var dentCount50mm60mm =
          (partData.DentsFromSize &&
            partData.DentsFromSize[5].DentCount50mm60mm) ||
          0;
        totalDentCount50mm60mm += dentCount50mm60mm;
      }
    }
    return totalDentCount50mm60mm;
  };
  getTotalDents70mm = () => {
    const { Dents } = this.state;
    var totalDentCount60mm70mm = 0;
    for (var i = 0; i < Dents && Dents.length; i++) {
      var partData = Dents[i];
      if (
        partData.Part !== "LeftFrontTyre" &&
        partData.Part !== "LeftBackTyre" &&
        partData.Part !== "RightFrontTyre" &&
        partData.Part !== "RightBackTyre" &&
        partData.Part !== "FrontBumper" &&
        partData.Part !== "LeftFrontBumper" &&
        partData.Part !== "LeftBackBumper" &&
        partData.Part !== "RightFrontBumper" &&
        partData.Part !== "RightBackBumper" &&
        partData.Part !== "BackBumper" &&
        partData.Part !== "Underbody" &&
        partData.Part !== "Inside"
      ) {
        var dentCount60mm70mm =
          (partData.DentsFromSize &&
            partData.DentsFromSize[6].DentCount60mm70mm) ||
          0;
        totalDentCount60mm70mm += dentCount60mm70mm;
      }
    }
    return totalDentCount60mm70mm;
  };
  getTotalDents80mm = () => {
    const { Dents } = this.state;
    var totalDentCount70mm80mm = 0;
    for (var i = 0; i < Dents && Dents.length; i++) {
      var partData = Dents[i];
      if (
        partData.Part !== "LeftFrontTyre" &&
        partData.Part !== "LeftBackTyre" &&
        partData.Part !== "RightFrontTyre" &&
        partData.Part !== "RightBackTyre" &&
        partData.Part !== "FrontBumper" &&
        partData.Part !== "LeftFrontBumper" &&
        partData.Part !== "LeftBackBumper" &&
        partData.Part !== "RightFrontBumper" &&
        partData.Part !== "RightBackBumper" &&
        partData.Part !== "BackBumper" &&
        partData.Part !== "Underbody" &&
        partData.Part !== "Inside"
      ) {
        var dentCount70mm80mm =
          (partData.DentsFromSize &&
            partData.DentsFromSize[7].DentCount70mm80mm) ||
          0;
        totalDentCount70mm80mm += dentCount70mm80mm;
      }
    }
    return totalDentCount70mm80mm;
  };

  handleDentsUpdate = () => {
    const { Dents, data } = this.state;
    data["TotalDentsFromSize"][0].DentCount0mm10mm = this.getTotalDents10mm();
    data["TotalDentsFromSize"][1].DentCount10mm20mm = this.getTotalDents20mm();
    data["TotalDentsFromSize"][2].DentCount20mm30mm = this.getTotalDents30mm();
    data["TotalDentsFromSize"][3].DentCount30mm40mm = this.getTotalDents40mm();
    data["TotalDentsFromSize"][4].DentCount40mm50mm = this.getTotalDents50mm();
    data["TotalDentsFromSize"][5].DentCount50mm60mm = this.getTotalDents60mm();
    data["TotalDentsFromSize"][6].DentCount60mm70mm = this.getTotalDents70mm();
    data["TotalDentsFromSize"][7].DentCount70mm80mm = this.getTotalDents80mm();
    const url =
      configuration.PostEditorChanges +
      `?partnerId=${localStorage.getItem(
        "partnerId"
      )}&vin=${localStorage.getItem(
        "selectedFile"
      )}&TabViewUpdated=${!data.TabViewUpdated}`;

    Axios.post(url, { ...data, Dents, IsPriceTableUpdated: true }).then((res) => {
      Toast.fire({
        type: "success",
        title: "Data saved successfully",
      });
    });
  };

  render() {
    const dynamic_Table_Colors = {
      "--table-even-color": this.state.rgbaColor || "#E8F3FF",
      "--table-header-color": this.state.insuaranceProvider.PrimaryColor || this.state.PrimaryColor || "#D80707",
      "--table-footer-color": this.state.insuaranceProvider.SecondaryColor || this.state.SecondaryColor || "#000",
      "--table-header-text-color": this.state.insuaranceProvider.HeaderTextColor || this.state.PrimaryTextColor || "#000",
      "--table-footer-text-color": this.state.insuaranceProvider.FooterTextColor || this.state.SecondaryTextColor || "#fff",
    };

    const { viewType } = this.props;
    const { data, Authorized, Dents, modal, imgPartName, ShowAW, Hood, universal_scan } =
      this.state;
    const [partnerId, vin] = [
      localStorage.getItem("partnerId"),
      localStorage.getItem("selectedFile"),
    ];
    const { is_extra_columns_visible, is_extra_columns_dentsize_show } =
      this.props;
    let numberOfZeros = 0;
    let dentSizeData = 0;
    let averageDentsSizeTotal = 0;
    let dentsData =
      Dents &&
      Dents.forEach((dents) => {
        if (dents.AvgDiaMm === 0) {
          numberOfZeros++;
        } else {
          dentSizeData += dents.AvgDiaMm && dents.AvgDiaMm != undefined ? dents.AvgDiaMm : 0;
        }
      });
    averageDentsSizeTotal =
      Dents && Dents.length !== 0
        ? Math.round(dentSizeData / (Dents.length - numberOfZeros))
        : 0;

    if (averageDentsSizeTotal >= 1 && averageDentsSizeTotal <= 19) {
      averageDentsSizeTotal = 20;
    }
    function findWithAttr(array, attr, value) {
      for (var i = 0; i < array.length; i += 1) {
        if (array[i][attr] === value) {
          return i;
        }
      }
      return -1;
    }
    return (
      <div
        className={`dns-pricetable all-price-table-wrapper  ${this.props.viewType === "TabView"
          ? "container-fluid dns_tabview_priceTable"
          : "title-row-main container"
          }`}
      >
        <div className="row dns-price-table-row">
          <div className="col-12 p-0 d-flex justify-content-between">
            <div className="row p-0">
              <div className="col-lg-6 col-md-12 col-sm-12 p-0">
                <h3 className="report-title">

                  {configuration.getVersionUrl == "https://backend.drivenscan.live" && localStorage.getItem("client") == "DNS" ? this.lang("Schaden pro Bauteil") : this.lang("Damage Description")}{" "}
                </h3>
              </div>
              {is_extra_columns_dentsize_show && (
                <div className="col-lg-6 col-md-12 col-sm-12 p-0">
                  <div className="d-flex align-items-center justify-content-end">
                    {/* <button 
                         className='detailed_update_btn'
                        style={{
                          // padding:'5px',
                          marginLeft:"10px",
                          backgroundColor:'#F20000', 
                          padding: "5px 10px",
                          color : 'white',
                          border: "none",
                          borderRadius: "5px",
                          fontSize: "16px"
                        }}
                        onClick={this.handleDentsUpdate}
                        disabled={Authorized}
                      >
                        {this.lang("Update Table")}
                      </button> */}
                  </div>
                </div>
              )}
              {this.props.is_extra_columns_visible && (
                <div className="col-lg-6 col-md-12 col-sm-12 text-right p-0 end-position-btn">
                  <div className="d-flex align-items-center justify-content-end">
                    <>
                      <div className="admin-list">
                        <label className="name pr-2">
                          {this.lang("ShowAW")}
                        </label>
                        <div className="switch-button switch-button-lg">
                          <input
                            type="checkbox"
                            name="ShowAW"
                            id="ShowAW"
                            value={ShowAW}
                            onClick={(e) => this.ShowAW(e)}
                            checked={ShowAW}
                            disabled={Authorized}
                          />
                          <span>
                            <label for="ShowAW"></label>
                          </span>
                        </div>
                      </div>
                      <button
                        //  className='SubmitBut'
                        style={{
                          // padding:'5px',
                          marginLeft: "10px",
                          backgroundColor: "#F20000",
                          padding: "5px 10px",
                          color: "white",
                          border: "none",
                          borderRadius: "5px",
                          fontSize: "16px",
                          // width: "120px"
                        }}
                        onClick={this.handleSave}
                        disabled={Authorized}
                      >
                        {
                          // isUpdateBtnLoading ? (
                          //   <Spinner style={{ height: '1rem', width: '1rem' }} size="sm" />
                          // ) : (
                          this.lang("Update Table")
                          // )
                        }
                      </button>
                    </>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div
          className={`row german-price-table-row damage-summary-table german_price_table 
            ${this.props.viewType === "TabView"
              ? "arrow_table_main_wrapper"
              : ""
            } 
            ${is_extra_columns_dentsize_show ? "details_report_table" : ""}`}
        >
          <div className="col-lg-12 p-0">
            <div className="table-responsive">
              <table width="100%" className=" table table-responsive-lg w-100 pb-3">
                <thead
                  className={`${localStorage.getItem("partnerId") === "WW-001"
                    ? "temporary_price_table_color"
                    : ""
                    } ${is_extra_columns_dentsize_show && "details_report_heading"
                    }`}
                >
                  <tr width="100%">
                    {is_extra_columns_dentsize_show ? (
                      <th
                        style={dynamic_Table_Colors}
                        rowSpan={2}
                        width={
                          this.props.viewType === "TabView" ? "10%" : "30%"
                        }
                        className={`part-tr both-top-border text-left ${this.props.viewType === "TabView"
                          ? "thead_bottom_border"
                          : "title-row-main"
                          }`}
                      >
                        {this.lang("DamageDescription")}
                      </th>
                    ) : (
                      <>
                        <th
                          style={dynamic_Table_Colors}
                          width={
                            this.props.viewType === "TabView" ? "10%" : "30%"
                          }
                          className={`part-tr both-top-border p-0 m-0 text-left ${this.props.viewType === "TabView"
                            ? "thead_bottom_border"
                            : "title-row-main"
                            }`}
                        >
                          {this.lang("DamageDescription")}
                        </th>
                      </>
                    )}
                    {/* {(window.localStorage.getItem("partnerId") === "002-sa" ||
                      window.localStorage.getItem("partnerId") === "demo-de" ||
                      window.localStorage.getItem("partnerId") === "demo-au" ||
                      window.localStorage.getItem("partnerId") ===
                        "demo-nl") && (
                      <> */}
                    <th className="empty_row"></th>
                    <th
                      rowSpan={2}
                      className={`replace-tr text-center both-top-border ${this.props.viewType === "TabView"
                        ? "thead_bottom_border dark-gray-col"
                        : ""
                        }`}
                      width={is_extra_columns_visible ? "5%" : "15%"}
                      style={{
                        minWidth: "70px",
                        padding: 0,
                        ...dynamic_Table_Colors,
                      }}
                    >
                      {this.lang("plastic")}
                    </th>

                    {universal_scan == '1' ?
                      <>
                        <th className="empty_row"></th>
                        <th
                          rowSpan={2}
                          className={`replace-tr text-center both-top-border ${this.props.viewType === "TabView"
                            ? "thead_bottom_border yellow-col"
                            : ""
                            }`}
                          width={is_extra_columns_visible ? "5%" : "15%"}
                          style={{
                            minWidth: "70px",
                            padding: 0,
                            ...dynamic_Table_Colors,
                          }}
                        >
                          {this.lang("Damage")}
                        </th>
                      </>
                      : ''
                    }
                    {/* </>
                    )} */}

                    {/* { viewType === "TabView" &&
                        <th className="empty_row"></th>
                        } */}
                    {!is_extra_columns_dentsize_show && (
                      <th className="empty_row"></th>
                    )}
                    {this.state.softwareType === "HailInspectionPlusDamage" ||
                      this.state.softwareType === "CarSoft" ? (
                      <th style={dynamic_Table_Colors} width={"2%"}>
                        {this.lang("Damages")}
                      </th>
                    ) : (
                      ""
                    )}

                    {/* <th className="empty_row"></th> */}
                    {is_extra_columns_dentsize_show && (
                      <>
                        <th className="empty_row"></th>
                        <th
                          style={dynamic_Table_Colors}
                          width={"40%"}
                          colSpan={7}
                          className={`both-top-border  ${this.props.viewType === "TabView"
                            ? "yellow-col"
                            : ""
                            }`}
                        >
                          {this.lang("dentSize")}
                        </th>
                        <th className="empty_row"></th>
                      </>
                    )}

                    {is_extra_columns_dentsize_show ? (
                      <th
                        rowSpan={2}
                        style={dynamic_Table_Colors}
                        width={"10%"}
                        className={`dents-tr both-top-border   ${this.props.viewType === "TabView"
                          ? "light-gray-col thead_bottom_border"
                          : ""
                          }`}
                      >
                        {
                          // localStorage.getItem('partnerId') === '10-200410'
                          //   ? this.lang("Total Scan Time")
                          //   :
                          this.lang("Total Dents")
                        }
                      </th>
                    ) : (
                      <>
                        <th
                          style={dynamic_Table_Colors}
                          width={"10%"}
                          className={`both-top-border ${this.props.viewType === "TabView"
                            ? "light-gray-col thead_bottom_border"
                            : ""
                            }`}
                        >
                          {
                            // localStorage.getItem('partnerId') === '10-200410'
                            //   ? this.lang("Total Scan Time")
                            //   :
                            this.lang("Total Dents")
                          }
                        </th>
                      </>
                    )}

                    <th className="empty_row"></th>

                    {is_extra_columns_dentsize_show ? (
                      <th
                        rowSpan={2}
                        style={{
                          minWidth: "70px",
                          padding: 0,
                          ...dynamic_Table_Colors,
                        }}
                        width={is_extra_columns_visible ? "5%" : "10%"}
                        className={`average-size-tr both-top-border   ${this.props.viewType === "TabView"
                          ? "yellow-col thead_bottom_border"
                          : ""
                          }`}
                      >
                        {this.lang("Average Size")}
                      </th>
                    ) : (
                      <>
                        <th
                          style={dynamic_Table_Colors}
                          width={is_extra_columns_visible ? "5%" : "10%"}
                          className={`average-size-tr both-top-border   ${this.props.viewType === "TabView"
                            ? "yellow-col thead_bottom_border"
                            : ""
                            }`}
                        >
                          {this.lang("Average Size")}
                        </th>
                      </>
                    )}

                    <th className="empty_row"></th>
                    {is_extra_columns_dentsize_show ? (
                      <>
                        <th
                          rowSpan={2}
                          style={{
                            minWidth: "70px",
                            padding: 0,
                            ...dynamic_Table_Colors,
                          }}
                          className={`alu-tr text-center both-top-border ${this.props.viewType === "TabView"
                            ? "thead_bottom_border"
                            : ""
                            }`}
                        >
                          {" "}
                          Alu
                          <br></br>
                          {this.state.alu_percentage
                            ? `(${parseInt(this.state.alu_percentage)}%)`
                            : "10%"}
                        </th>
                        <th className="empty_row"></th>
                      </>
                    ) : (
                      // ) : (
                      //   <>
                      //     <th
                      //       style={{
                      //         minWidth: "70px",
                      //         padding: 0,
                      //         ...dynamic_Table_Colors,
                      //       }}
                      //       // width={is_extra_columns_visible ? "5%" : "10%"}
                      //       className={`alu-tr text-center top-left-border ${
                      //         this.props.viewType === "TabView"
                      //           ? "orange-col thead_bottom_border"
                      //           : ""
                      //       }`}
                      //       // style={{backgroundColor : this.state.PrimaryColor ? `${this.state.PrimaryColor}` : '#D92029'}}
                      //     >
                      //       {" "}
                      //       Alu
                      //       <br></br>
                      //       {this.state.ALUPercentage
                      //         ? `(${parseInt(this.state.ALUPercentage)}%)`
                      //         : "10%"}
                      //     </th>
                      <>
                        <th
                          style={{
                            minWidth: "70px",
                            padding: 0,
                            ...dynamic_Table_Colors,
                          }}
                          // width={is_extra_columns_visible ? "5%" : "10%"}
                          className={`alu-tr text-center both-top-border ${this.props.viewType === "TabView"
                            ? "orange-col thead_bottom_border"
                            : ""
                            }`}
                        // style={{backgroundColor : this.state.PrimaryColor ? `${this.state.PrimaryColor}` : '#D92029'}}
                        >
                          {" "}
                          Alu
                          <br></br>
                          {this.state.ALUPercentage
                            ? `(${parseInt(this.state.ALUPercentage)}%)`
                            : "10%"}
                        </th>
                        <th className="empty_row"></th>
                      </>
                    )}

                    {is_extra_columns_dentsize_show ? (
                      <>

                        <th
                          rowSpan={2}
                          width={is_extra_columns_visible ? "5%" : "10%"}
                          className={`lak-tr both-top-border  text-center ${this.props.viewType === "TabView"
                            ? "thead_bottom_border"
                            : ""
                            }`}
                          style={{
                            minWidth: "70px",
                            padding: 0,
                            ...dynamic_Table_Colors,
                          }}
                        >
                          {this.lang("Lak")}
                          <br></br>
                          {this.state.LAKPercentage
                            ? `(${parseInt(this.state.LAKPercentage)}%)`
                            : "10%"}
                        </th>
                        <th className="empty_row"></th>
                      </>
                    ) : (
                      <>
                        <th
                          width={is_extra_columns_visible ? "5%" : "10%"}
                          className={`lak-tr both-top-border text-center ${this.props.viewType === "TabView"
                            ? "green-col thead_bottom_border"
                            : ""
                            }`}
                          style={{
                            minWidth: "70px",
                            padding: 0,
                            ...dynamic_Table_Colors,
                          }}
                        >
                          {this.lang("Lak")}
                          <br></br>
                          {this.state.LAKPercentage
                            ? `(${parseInt(this.state.LAKPercentage)}%)`
                            : "10%"}
                        </th>
                        <th className="empty_row"></th>
                      </>
                    )}

                    {is_extra_columns_dentsize_show ? (
                      <th
                        rowSpan={2}
                        className={`replace-tr  text-center both-top-border ${this.props.viewType === "TabView"
                          ? "thead_bottom_border"
                          : ""
                          }`}
                        width={is_extra_columns_visible ? "5%" : "15%"}
                        style={{
                          minWidth: "70px",
                          padding: 0,
                          ...dynamic_Table_Colors,
                        }}
                      >
                        {this.lang("Glue")}
                        <br></br>
                        {this.state.GLUPercentage
                          ? `(${parseInt(this.state.GLUPercentage)}%)`
                          : "10%"}
                      </th>
                    ) : (
                      <>
                        <th
                          className={`replace-tr  text-center both-top-border ${this.props.viewType === "TabView"
                            ? "blue-col thead_bottom_border"
                            : ""
                            }`}
                          width={is_extra_columns_visible ? "5%" : "15%"}
                          style={{
                            minWidth: "70px",
                            padding: 0,
                            ...dynamic_Table_Colors,
                          }}
                        >
                          {this.lang("Glue")}
                          <br></br>
                          {this.state.GLUPercentage
                            ? `(${parseInt(this.state.GLUPercentage)}%)`
                            : "10%"}
                        </th>
                      </>
                    )}
                    {/* <th
                        width={is_extra_columns_visible ? "5%" : "15%"}
                        className="replace-tr"
                      >
                        <p className="p-0 m-0">
                        {this.lang("Replace")}
                        </p>
                      </th> */}
                    {this.props.is_extra_columns_visible && (
                      <>
                        <th className="empty_row"></th>
                        <th
                          width="15%"
                          className={`ae-tr both-top-border   ${this.props.viewType === "TabView"
                            ? "dark-gray-col thead_bottom_border"
                            : ""
                            }`}
                          style={dynamic_Table_Colors}
                        >
                          A + E
                        </th>
                        <th className="empty_row"></th>
                        {/* Ersetzen */}
                        <th
                          width="15%"
                          className={`ersetzen-tr both-top-border   ${this.props.viewType === "TabView"
                            ? "green-col thead_bottom_border"
                            : ""
                            }`}
                          style={dynamic_Table_Colors}
                        >
                          {this.lang("Replace")}
                        </th>
                      </>
                    )}
                    {ShowAW && (
                      <>
                        {is_extra_columns_dentsize_show ? (
                          <>
                            <th className="empty_row"></th>
                            <th
                              width="10%"
                              rowSpan={2}
                              className={`both-top-border aw-tr small_width_table large-height-content p-0 m-0 ${this.props.viewType === "TabView" ? "" : ""
                                }`}
                              style={{
                                ...dynamic_Table_Colors,
                                minWidth: "60px",
                              }}
                            >
                              Aw
                            </th>
                          </>
                        ) : (
                          <>
                            <th className="empty_row"></th>
                            <th
                              width="10%"
                              style={{
                                ...dynamic_Table_Colors,
                                minWidth: "60px",
                              }}
                              className={`both-top-border   aw-tr small_width_table large-height-content p-0 m-0 ${this.props.viewType === "TabView" ? "" : ""
                                }`}
                            >
                              Aw
                            </th>
                          </>
                        )}
                      </>
                    )}
                    {/* <th className="aw-tr">Aw1</th>
                      <th className="aw-tr">Aw2</th> */}
                  </tr>
                  {is_extra_columns_dentsize_show && (
                    <tr width="100%">
                      {/* <th></th> */}
                      <th rowSpan={2} className="empty_row"></th>
                      {universal_scan == '1' &&
                        <th rowSpan={2} className="empty_row"></th>
                      }
                      {/* {(window.localStorage.getItem("partnerId") === "002-sa" ||
                      window.localStorage.getItem("partnerId") === "demo-de" ||
                      window.localStorage.getItem("partnerId") === "demo-au" ||
                      window.localStorage.getItem("partnerId") ===
                        "demo-nl") && ( */}
                      <th rowSpan={2} className="empty_row"></th>
                      {/* )} */}
                      <th
                        style={dynamic_Table_Colors}
                        className="table-head-row"
                      >
                        10
                      </th>
                      <th
                        style={dynamic_Table_Colors}
                        className="table-head-row"
                      >
                        20
                      </th>
                      <th
                        style={dynamic_Table_Colors}
                        className="table-head-row"
                      >
                        30
                      </th>
                      <th
                        style={dynamic_Table_Colors}
                        className="table-head-row"
                      >
                        40
                      </th>
                      <th
                        style={dynamic_Table_Colors}
                        className="table-head-row"
                      >
                        50
                      </th>
                      <th
                        style={dynamic_Table_Colors}
                        className="table-head-row"
                      >
                        60
                      </th>
                      <th
                        style={dynamic_Table_Colors}
                        className="table-head-row"
                      >
                        70
                      </th>
                      {/* <th
                        style={dynamic_Table_Colors}
                        className="table-head-row"
                      >
                        80
                      </th> */}
                      {/* <th className="empty_row"></th> */}
                      {/* { ShowAW && <th>dfdfdfdfdfdf</th>} */}
                    </tr>
                  )}
                </thead>
                {/* <tbody width="100%" className={is_extra_columns_dentsize_show && 'details_report_body'}> */}
                <tbody
                  width="100%"
                  className={`${localStorage.getItem("partnerId") === "WW-001"
                    ? "temporary_price_table_color"
                    : ""
                    } ${is_extra_columns_dentsize_show && "details_report_body"}`}
                >
                  {/* <tr width="100%" >
                        <th width="37%">Part</th>
                        <th width="10%">Total Dents</th>
                        <th width="13%">Average Size (Roundoff)</th>
                        <th width="10%">Aw</th>
                        <th width="10%">Alu</th>
                        <th width="10%">Lak</th>
                        <th width="10%">Replace</th>
                      </tr> */}
                  {Dents &&
                    Dents.map((row, index) => {
                      return (
                        row.Part !== "LeftFrontTyre" &&
                        row.Part !== "LeftBackTyre" &&
                        row.Part !== "RightFrontTyre" &&
                        row.Part !== "RightBackTyre" &&
                        row.Part !== "FrontBumper" &&
                        row.Part !== "LeftFrontBumper" &&
                        row.Part !== "LeftBackBumper" &&
                        row.Part !== "RightFrontBumper" &&
                        row.Part !== "RightBackBumper" &&
                        row.Part !== "BackBumper" &&
                        row.Part !== "Underbody" &&
                        row.Part !== "Inside" && (
                          <tr className="" key={index}>
                            <td
                              style={dynamic_Table_Colors}
                              className="price-tbody-td"
                            >
                              <p
                                className="p-0 m-0"
                                onClick={() =>
                                  this.props.is_extra_columns_visible &&
                                  this.toggle(row.Part, true, row.Plastic)
                                }
                                style={{
                                  cursor: this.props.is_extra_columns_visible
                                    ? "pointer"
                                    : "",
                                  textDecoration: this.props
                                    .is_extra_columns_visible
                                    ? ""
                                    : "",
                                }}
                              >
                                {this.lang(row.Part)}
                              </p>
                              {(Array.isArray(row.AE) && row.AE.length) ||
                                (Array.isArray(row.Ersetzen) &&
                                  row.Ersetzen.length) ? (
                                <p className="p-0 m-0">
                                  {!this.props.is_extra_columns_visible && (
                                    <>
                                      {/* <br></br> */}
                                      {Array.isArray(row.AE) && row.AE.length
                                        ? "("
                                        : ""}
                                      {Array.isArray(row.AE) &&
                                        row.AE.map((data, index) => {
                                          return (
                                            <span>
                                              {this.lang(data)}
                                              {index == row.AE.length - 1
                                                ? ""
                                                : ", "}
                                            </span>
                                          );
                                        })}
                                      {Array.isArray(row.AE) && row.AE.length
                                        ? ")"
                                        : ""}
                                      {/* {Array.isArray(row.AE) && row.AE.length ? (
                                      <br />
                                    ) : (
                                      <></>
                                    )} */}
                                      {Array.isArray(row.Ersetzen) &&
                                        row.Ersetzen.length
                                        ? "("
                                        : ""}
                                      {Array.isArray(row.Ersetzen) &&
                                        row.Ersetzen.map((data, index) => {
                                          return (
                                            <span>
                                              {this.lang(data)}
                                              {index == row.Ersetzen.length - 1
                                                ? ""
                                                : ", "}
                                            </span>
                                          );
                                        })}
                                      {Array.isArray(row.Ersetzen) &&
                                        row.Ersetzen.length
                                        ? ")"
                                        : ""}
                                    </>
                                  )}
                                </p>
                              ) : null}
                            </td>
                            {/* {(window.localStorage.getItem("partnerId") ===
                              "002-sa" ||
                              window.localStorage.getItem("partnerId") ===
                                "demo-de" ||
                              window.localStorage.getItem("partnerId") ===
                                "demo-au" ||
                              window.localStorage.getItem("partnerId") ===
                                "demo-nl") && (
                              <> */}
                            <td className="empty_row"></td>
                            <td
                              style={dynamic_Table_Colors}
                              className={`price-tbody-td text-center ${this.props.viewType === "TabView"
                                ? "dark-gray-col"
                                : ""
                                } `}
                            >
                              {row.Part === "TrunkCover" &&
                                data[findWithAttr(data, "Part", "Trunk")] ? (
                                this.props.viewType === "TabView" ? (
                                  <input
                                    type="checkbox"
                                    className="cross_input"
                                    checked={
                                      row.Plastic ||
                                      data[
                                        findWithAttr(data, "Part", "Trunk")
                                      ].Plastic
                                    }
                                    disabled={Authorized}
                                    onChange={(e) => {
                                      this.plasticChange(
                                        row.Part,
                                        e,
                                        index,
                                        "Plastic"
                                      );
                                    }}
                                  />
                                ) : row.Plastic ? (
                                  <span style={{ fontSize: "16px" }}>
                                    <i className="fa fa-close"></i>
                                  </span>
                                ) : (
                                  ""
                                )
                              ) : this.props.viewType === "TabView" ? (
                                <input
                                  type="checkbox"
                                  className="cross_input"
                                  checked={row.Plastic}
                                  disabled={Authorized}
                                  onChange={(e) => {
                                    this.plasticChange(
                                      row.Part,
                                      e,
                                      index,
                                      "Plastic"
                                    );
                                  }}
                                />
                              ) : row.Plastic ? (
                                <span style={{ fontSize: "16px" }}>
                                  <i className="fa fa-close"></i>
                                </span>
                              ) : (
                                ""
                              )}
                            </td>
                            {universal_scan == '1' ?
                              <>
                                <td className="empty_row"></td>
                                <td
                                  style={dynamic_Table_Colors}
                                  className={`price-tbody-td text-center ${this.props.viewType === "TabView"
                                    ? "yellow-col"
                                    : ""
                                    } `}
                                >
                                  {row.Part === "TrunkCover" &&
                                    data[findWithAttr(data, "Part", "Trunk")] ? (
                                    this.props.viewType === "TabView" ? (
                                      <input
                                        name="DamageCount"
                                        type="number"
                                        style={{
                                          width: "100%",
                                          border: "none",
                                          outline: "none",
                                          textAlign: "center",
                                        }}
                                        value={row.DamageCount}
                                        disabled="true"
                                      />
                                    ) : row.DamageCount
                                  ) : this.props.viewType === "TabView" ? (
                                    <input
                                      name="DamageCount"
                                      type="number"
                                      style={{
                                        width: "100%",
                                        border: "none",
                                        outline: "none",
                                        textAlign: "center",
                                      }}
                                      value={row.DamageCount}
                                      disabled='true'
                                    />
                                  ) : row.DamageCount}
                                </td>
                              </>
                              : ''
                            }
                            {/* </>
                            )} */}

                            <td className="empty_row"></td>
                            {/* show damges */}

                            {this.state.softwareType ===
                              "HailInspectionPlusDamage" ||
                              this.state.softwareType === "CarSoft" ? (
                              <td
                                className="price-tbody-td"
                                style={dynamic_Table_Colors}
                              >
                                <p className="p-0 m-0">
                                  {row.TotalDamages ? row.TotalDamages : 0}
                                </p>
                              </td>
                            ) : (
                              ""
                            )}

                            {is_extra_columns_dentsize_show &&
                              [
                                "DentCount0mm10mm",
                                "DentCount10mm20mm",
                                "DentCount20mm30mm",
                                "DentCount30mm40mm",
                                "DentCount40mm50mm",
                                "DentCount50mm60mm",
                                "DentCount60mm70mm",
                                // "DentCount70mm80mm",
                              ].map((destsSize, i) => (
                                // <>
                                //   <td
                                //     className="table-row-body price-tbody-td"
                                //     style={dynamic_Table_Colors}
                                //   >
                                //     <input
                                //       type="number"
                                //       min="0"
                                //       name="destsSize"
                                //       value={
                                //         Dents[index]["DentsFromSize"][
                                //               destsSize
                                //             ] || 0
                                //       }
                                //       className="dents_size"
                                //       placeholder=""
                                //       readOnly
                                //       onChange={(e) =>
                                //         !row.Plastic &&
                                //         this.handleDentsChange(
                                //           row,
                                //           index,
                                //           e,
                                //           destsSize,
                                //           i
                                //         )
                                //       }
                                //     ></input>
                                //   </td>
                                // </>
                                <>
                                  <td
                                    className="table-row-body price-tbody-td"
                                    style={dynamic_Table_Colors}
                                  >
                                    <input
                                      type="number"
                                      min="0"
                                      name="destsSize"
                                      value={
                                        Dents[index]["DentsFromSize"]
                                          ? Dents[index]["DentsFromSize"][
                                          destsSize
                                          ] || 0
                                          : 0
                                      }
                                      className="dents_size"
                                      placeholder=""
                                      readOnly
                                      onChange={(e) =>
                                        this.handleDentsChange(
                                          row,
                                          index,
                                          e,
                                          destsSize,
                                          i
                                        )
                                      }
                                    ></input>
                                  </td>
                                </>
                              ))}

                            {is_extra_columns_dentsize_show && (
                              <td className="empty_row"></td>
                            )}
                            {/* show damges */}

                            <td
                              className={`text_table_width price-tbody-td text-center ${this.props.viewType === "TabView"
                                ? "light-gray-col"
                                : ""
                                }`}
                              style={dynamic_Table_Colors}
                            >
                              {this.props.is_extra_columns_visible ? (
                                <div
                                  style={{
                                    position: "relative",
                                    width: "100%",
                                  }}
                                >
                                  <input
                                    name="TotalDents"
                                    type="number"
                                    style={{
                                      width: "100%",
                                      border: "none",
                                      outline: "none",
                                      textAlign: "center",
                                      color: row.Replace ? "red" : "black",
                                    }}
                                    value={row.Plastic ? 0 : row.TotalDents}
                                    min="0"
                                    // max='80'
                                    onChange={(e) =>
                                      !row.Plastic &&
                                      this.handleChange(row.Part, index, e)
                                    }
                                    disabled={Authorized}
                                  />
                                  {!Authorized && (
                                    <>
                                      <div className="button-table-arrow-position">
                                        <button
                                          onClick={() => {
                                            const updatedValue = Math.max(
                                              (parseInt(row.TotalDents) || 0) -
                                              1,
                                              0
                                            );
                                            this.handleChange(row.Part, index, {
                                              target: {
                                                name: "TotalDents",
                                                value: updatedValue,
                                              },
                                            });
                                          }}
                                          disabled={Authorized || row.Plastic}
                                          className="decrement-button"
                                        >
                                          -
                                        </button>
                                        <button
                                          onClick={() => {
                                            const updatedValue =
                                              (parseInt(row.TotalDents) || 0) +
                                              1;
                                            this.handleChange(row.Part, index, {
                                              target: {
                                                name: "TotalDents",
                                                value: updatedValue,
                                              },
                                            });
                                          }}
                                          disabled={Authorized || row.Plastic}
                                          className="increment-button"
                                        >
                                          +
                                        </button>
                                      </div>
                                    </>
                                  )}
                                </div>
                              ) : (
                                <p
                                  style={{
                                    color: `${row.TotalDents > 250 ? "red" : ""
                                      }`,
                                  }}
                                  className="p-0 m-0"
                                >
                                  {row.TotalDents}
                                </p>
                              )}
                            </td>
                            <td className="empty_row"></td>

                            <td
                              className={`text_table_width price-tbody-td text-center ${this.props.viewType === "TabView"
                                ? "yellow-col"
                                : ""
                                }`}
                              style={dynamic_Table_Colors}
                            >
                              {/* {avgSizeRoundOff[index]} */}

                              {(partnerId === "10-200410-2" || partnerId === "10-200410") ? (
                                this.props.is_extra_columns_visible ? (
                                  this.state.loadedFirstTime ? (
                                    <div style={{ position: "relative", width: "100%" }}>
                                      <input
                                        name="AvgDiaMm"
                                        type="number"
                                        style={{ width: "100%", border: "none", outline: "none", textAlign: "center" }}
                                        value={row.Plastic ? 0 : row.AvgDiaMm == 10 ? 20 : row.AvgDiaMm}
                                        min="0"
                                        step="10"
                                        max="80"
                                        onChange={(e) => {
                                          this.handleInputChange(e, row, index)
                                        }}
                                        disabled={Authorized}
                                      />
                                      {!Authorized && (
                                        <div className="button-table-arrow-position">
                                          <button
                                            onClick={() => {
                                              const updatedValue = Math.max((parseInt(row.AvgDiaMm, 10) || 0) - (row.AvgDiaMm === 20 ? 20 : 10), 0);
                                              this.handleChange(row.Part, index, { target: { name: "AvgDiaMm", value: updatedValue } });
                                            }}
                                            disabled={Authorized || row.Plastic}
                                            className="decrement-button"
                                          >
                                            -
                                          </button>
                                          <button
                                            onClick={() => {
                                              const updatedValue = (parseInt(row.AvgDiaMm, 10) || 0) + (row.AvgDiaMm === 0 ? 20 : 10);
                                              this.handleChange(row.Part, index, { target: { name: "AvgDiaMm", value: updatedValue } });
                                            }}
                                            disabled={Authorized || row.Plastic}
                                            className="increment-button"
                                          >
                                            +
                                          </button>
                                        </div>
                                      )}
                                    </div>
                                  ) : (
                                    <div style={{ position: "relative", width: "100%" }}>
                                      <input
                                        name="AvgDiaMm"
                                        type="number"
                                        style={{ width: "100%", border: "none", outline: "none", textAlign: "center" }}
                                        value={row.Plastic ? 0 : row.AvgDiaMm == 10 ? 20 : row.AvgDiaMm}
                                        min="0"
                                        step="10"
                                        onChange={(e) => {
                                          this.handleInputChange(e, row, index)
                                        }}
                                        disabled={Authorized}
                                      />
                                      {!Authorized && (
                                        <div className="button-table-arrow-position">
                                          <button
                                            onClick={() => {
                                              const updatedValue = Math.max((parseInt(row.AvgDiaMm, 10) || 0) - (row.AvgDiaMm === 20 ? 20 : 10), 0);
                                              this.handleChange(row.Part, index, { target: { name: "AvgDiaMm", value: updatedValue } });
                                            }}
                                            disabled={Authorized || row.Plastic}
                                            className="decrement-button"
                                          >
                                            -
                                          </button>
                                          <button
                                            onClick={() => {
                                              const updatedValue = (parseInt(row.AvgDiaMm, 10) || 0) + (row.AvgDiaMm === 0 ? 20 : 10);
                                              this.handleChange(row.Part, index, { target: { name: "AvgDiaMm", value: updatedValue } });
                                            }}
                                            disabled={Authorized || row.Plastic}
                                            className="increment-button"
                                          >
                                            +
                                          </button>
                                        </div>
                                      )}
                                    </div>
                                  )
                                ) : (
                                  <p className="p-0 m-0">
                                    {row.Plastic ? 0 : (this.round10(row.AvgDiaMm == 10 ? 20 : row.AvgDiaMm, 1) * 0.0393701).toFixed(2)}
                                  </p>
                                )
                              ) : this.props.is_extra_columns_visible ? (
                                this.state.loadedFirstTime ? (
                                  <div style={{ position: "relative", width: "100%" }}>
                                    <input
                                      name="AvgDiaMm"
                                      type="number"
                                      style={{ width: "100%", border: "none", outline: "none", textAlign: "center" }}
                                      value={
                                        row.Plastic
                                          ? 0
                                          : this.round10(row.AvgDiaMm == 10 ? 20 : row.AvgDiaMm, 1)
                                      }
                                      min="0"
                                      step="10"
                                      max="80"
                                      onChange={(e) =>
                                        !row.Plastic &&
                                        this.handleInputChange(e, row, index)
                                      }
                                      disabled={Authorized}
                                    />
                                    {!Authorized && (
                                      <div className="button-table-arrow-position">
                                        <button
                                          onClick={() => {
                                            const updatedValue = Math.max((parseInt(row.AvgDiaMm, 10) || 0) - (row.AvgDiaMm === 20 ? 20 : 10), 0);
                                            this.handleChange(row.Part, index, { target: { name: "AvgDiaMm", value: updatedValue } });
                                          }}
                                          disabled={Authorized || row.Plastic}
                                          className="decrement-button"
                                        >
                                          -
                                        </button>
                                        <button
                                          onClick={() => {
                                            const updatedValue = (parseInt(row.AvgDiaMm, 10) || 0) + (row.AvgDiaMm === 0 ? 20 : 10);
                                            this.handleChange(row.Part, index, { target: { name: "AvgDiaMm", value: updatedValue } });
                                          }}
                                          disabled={Authorized || row.Plastic}
                                          className="increment-button"
                                        >
                                          +
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                ) : (
                                  <div style={{ position: "relative", width: "100%" }}>
                                    <input
                                      name="AvgDiaMm"
                                      type="number"
                                      style={{ width: "100%", border: "none", outline: "none", textAlign: "center" }}
                                      value={row.Plastic ? 0 : row.AvgDiaMm == 10 ? 20 : row.AvgDiaMm}
                                      min="0"
                                      step="10"
                                      onChange={(e) =>
                                        !row.Plastic &&
                                        this.handleInputChange(e, row, index)
                                      }
                                      disabled={Authorized}
                                    />
                                    {!Authorized && (
                                      <div className="button-table-arrow-position">
                                        <button
                                          onClick={() => {
                                            const updatedValue = Math.max((parseInt(row.AvgDiaMm, 10) || 0) - (row.AvgDiaMm === 20 ? 20 : 10), 0);
                                            this.handleChange(row.Part, index, { target: { name: "AvgDiaMm", value: updatedValue } });
                                          }}
                                          disabled={Authorized || row.Plastic}
                                          className="decrement-button"
                                        >
                                          -
                                        </button>
                                        <button
                                          onClick={() => {
                                            const updatedValue = (parseInt(row.AvgDiaMm, 10) || 0) + (row.AvgDiaMm === 0 ? 20 : 10);
                                            this.handleChange(row.Part, index, { target: { name: "AvgDiaMm", value: updatedValue } });
                                          }}
                                          disabled={Authorized || row.Plastic}
                                          className="increment-button"
                                        >
                                          +
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                )
                              ) : (
                                <p className="p-0 m-0">
                                  {row.Plastic ? 0 : this.round10(row.AvgDiaMm == 10 ? 20 : row.AvgDiaMm, 1)}
                                </p>
                              )}
                              {/* {this.round10(row.AvgDiaMm, 1)} */}
                              {/* {row.AvgDiaMm} */}
                            </td>
                            <td className="empty_row"></td>
                            <td
                              style={dynamic_Table_Colors}
                              className={`price-tbody-td  ${this.props.viewType === "TabView"
                                ? "orange-col"
                                : ""
                                }`}
                            >
                              {is_extra_columns_visible ? (
                                <>
                                  <input
                                    className="cross_input_table"
                                    type="checkbox"
                                    checked={row.Plastic ? false : row.Alu}
                                    onChange={(e) => {
                                      !row.Plastic &&
                                        this.change(row.Part, e, index, "Alu");
                                    }}
                                    id={index + "Alu"}
                                    disabled={Authorized}
                                  />
                                  <label className="" for={index + "Alu"} />
                                </>
                              ) : row.Alu ? (
                                <span style={{ fontSize: "16px" }}>
                                  <i className="fa fa-close"></i>
                                </span>
                              ) : (
                                ""
                              )}
                            </td>
                            <td className="empty_row"></td>
                            <td
                              style={dynamic_Table_Colors}
                              className={`price-tbody-td ${this.props.viewType === "TabView"
                                ? "green-col"
                                : ""
                                }`}
                            >
                              {is_extra_columns_visible ? (
                                <>
                                  <input
                                    className="cross_input_table"
                                    type="checkbox"
                                    checked={universal_scan == '1' ? row.Push2paint :
                                      row.Plastic ? false : row.Push2paint
                                    }
                                    onChange={(e) => {
                                      !row.Plastic &&
                                        this.change(
                                          row.Part,
                                          e,
                                          index,
                                          "Push2paint"
                                        );
                                    }}
                                    id={index + "Push2paint"}
                                    disabled={universal_scan == '1' ? true : Authorized}
                                  // disabled='true'
                                  />
                                  <label
                                    className=""
                                    for={index + "Push2paint"}
                                  />
                                </>
                              ) : row.Push2paint ? (
                                <span style={{ fontSize: "16px" }}>
                                  <i className="fa fa-close"></i>
                                </span>
                              ) : (
                                ""
                              )}
                            </td>
                            <td className="empty_row"></td>
                            <td
                              style={dynamic_Table_Colors}
                              className={`price-tbody-td ${this.props.viewType === "TabView"
                                ? "blue-col"
                                : ""
                                }`}
                            >
                              {is_extra_columns_visible ? (
                                <>
                                  <input
                                    className="cross_input_table"
                                    type="checkbox"
                                    checked={row.Plastic ? false : row.Glue}
                                    onChange={(e) => {
                                      !row.Plastic &&
                                        this.change(row.part, e, index, "Glue");
                                    }}
                                    id={index + "Glue"}
                                    disabled={Authorized}
                                  />
                                  <label className="" for={index + "Glue"} />
                                </>
                              ) : row.Glue ? (
                                <span style={{ fontSize: "16px" }}>
                                  <i className="fa fa-close"></i>
                                </span>
                              ) : (
                                ""
                              )}
                            </td>
                            {/* <td className="empty_row"></td> */}
                            {/* Replace */}
                            {/* <td className="" style={{ textAlign: "center" }}>
                            {is_extra_columns_visible ? 
                              <>
                                <input
                                  className="custom-control-input"
                                  type="checkbox"
                                  checked={row.Replace}
                                  onChange={(e) => {
                                    this.change(row.part, e, index, "Replace");
                                  }}
                                  id={index + "Replace"}
                                  disabled={Authorized}
                                />
                                <label
                                  className="custom-control-label"
                                  for={index + "Replace"}
                                />
                              </>
                            :
                              row.Replace ? <span style={{fontSize:"20px"}}><i className="fa fa-check"></i></span> : ''
                            }
                          </td> */}

                            {/* <td className="" style={{ textAlign: "center" }}>
                          {row.AW}
                        </td>*/}
                            {this.props.is_extra_columns_visible && (
                              <>
                                <td className="empty_row"></td>
                                <td
                                  style={dynamic_Table_Colors}
                                  className={`price-tbody-td ${this.props.viewType === "TabView"
                                    ? "dark-gray-col"
                                    : ""
                                    }`}
                                >
                                  <div className="ae-content p-0">
                                    <div className="row p-0">
                                      {Array.isArray(row.arrAE) &&
                                        row.arrAE.map((checkbox_val) => {
                                          return (
                                            <>
                                              <div className="col-lg-12 col-md-12 col-sm-12 p-0 d-flex text-left">
                                                <div className="alu_input_main">
                                                  <div className="alu_input_content">
                                                    <input
                                                      className="cross_input_table"
                                                      type="checkbox"
                                                      checked={
                                                        Array.isArray(
                                                          Dents[index]["AE"]
                                                        ) &&
                                                          Dents[index][
                                                            "AE"
                                                          ].includes(checkbox_val)
                                                          ? true
                                                          : false
                                                      }
                                                      onClick={(event) =>
                                                        this.changeAE(
                                                          event,
                                                          index,
                                                          checkbox_val
                                                        )
                                                      }
                                                      disabled={Authorized}
                                                    />
                                                  </div>
                                                  <div className="alu_para_content">
                                                    <p className="p-0 m-0">
                                                      {this.lang(checkbox_val)}
                                                    </p>
                                                  </div>
                                                </div>
                                                {/* <div className="row p-0">
                                                <div className="col-2 p-0">
                                                  <input
                                                  className="cross_input_table"
                                                    type="checkbox"
                                                    checked={
                                                      Array.isArray(
                                                        Dents[index]["AE"]
                                                      ) &&
                                                      Dents[index]["AE"].includes(
                                                        checkbox_val
                                                      )
                                                        ? true
                                                        : false
                                                    }
                                                    onClick={(event) =>
                                                      this.changeAE(
                                                        event,
                                                        index,
                                                        checkbox_val
                                                      )
                                                    }
                                                    disabled={Authorized}
                                                  />
                                                </div>
                                                <div className="col-10 p-0">
                                                  <p className="p-0 m-0">
                                                    {this.lang(checkbox_val)}</p>
                                                </div>
                                              </div> */}
                                              </div>
                                            </>
                                          );
                                        })}
                                    </div>
                                  </div>
                                </td>
                                <td className="empty_row"></td>
                                <td
                                  style={dynamic_Table_Colors}
                                  className={`price-tbody-td ${this.props.viewType === "TabView"
                                    ? "green-col"
                                    : ""
                                    }`}
                                >
                                  <div className="ae-content p-0">
                                    <div className="row p-0">
                                      {Array.isArray(row.arrErsetzen) &&
                                        row.arrErsetzen.map((checkbox_val) => {
                                          return (
                                            <>
                                              <div className="col-lg-12 col-md-12 col-sm-12 p-0 d-flex text-left">
                                                <div className="alu_input_main">
                                                  <div className="alu_input_content">
                                                    <input
                                                      className="cross_input_table"
                                                      type="checkbox"
                                                      checked={
                                                        Array.isArray(
                                                          Dents[index][
                                                          "Ersetzen"
                                                          ]
                                                        ) &&
                                                          Dents[index][
                                                            "Ersetzen"
                                                          ].includes(checkbox_val)
                                                          ? true
                                                          : false
                                                      }
                                                      onClick={(event) => {
                                                        this.changeErsetzen(
                                                          event,
                                                          index,
                                                          checkbox_val
                                                        );
                                                        // this.change(row.part, event, index, "Replace")
                                                      }}
                                                      disabled={Authorized}
                                                    />
                                                  </div>
                                                  <div className="alu_para_content">
                                                    <p className="p-0 m-0">
                                                      {this.lang(checkbox_val)}
                                                    </p>
                                                  </div>
                                                </div>

                                                {/* <div className="row p-0">
                                                <div className="col-2 p-0">
                                                  <input
                                                    className="cross_input_table"
                                                    type="checkbox"
                                                    checked={
                                                      Array.isArray(
                                                        Dents[index]["Ersetzen"]
                                                      ) &&
                                                      Dents[index][
                                                        "Ersetzen"
                                                      ].includes(checkbox_val)
                                                        ? true
                                                        : false
                                                    }
                                                    onClick={(event) =>
                                                      {
                                                        this.changeErsetzen(
                                                          event,
                                                          index,
                                                          checkbox_val
                                                          )
                                                          // this.change(row.part, event, index, "Replace")
                                                        }
                                                    }
                                                    disabled={Authorized}
                                                  />
                                                </div>
                                                <div className="col-10 p-0">
                                                <p className="p-0 m-0">{this.lang(checkbox_val)}</p>
                                                </div>
                                              </div> */}
                                              </div>
                                            </>
                                          );
                                        })}
                                    </div>
                                    {/* </div> */}
                                  </div>
                                </td>
                              </>
                            )}

                            {ShowAW && (
                              <>
                                <td className="empty_row"></td>
                                {/* <price-tbody-td
                                  style={dynamic_Table_Colors}
                                  className="price-tbody-td"
                                >
                                  {this.props.is_extra_columns_visible ? (
                                    <input
                                      name="AW"
                                      type="number"
                                      style={{
                                        width: "100%",
                                        minWidth: "20%",
                                        border: "none",
                                        outline: "none",
                                        textAlign: "center",
                                      }}
                                      value={row.Plastic ? 0 : row.AW}
                                      min="0"
                                      onChange={(e) =>
                                        !row.Plastic && this.handleChange(row.Part, index, e)
                                      }
                                      disabled={Authorized}
                                    />
                                  ) : (
                                    <p className="p-0 m-0">{row.AW}</p>
                                  )}
                                </td> */}
                                <td
                                  style={dynamic_Table_Colors}
                                  className="price-tbody-td"
                                >
                                  <p className="p-0 m-0">
                                    {
                                      row.Plastic ? 0 : row.Replace ? 0 : row.AW
                                    }
                                    {/* {row.Plastic ? 0 : row.AW} */}
                                  </p>
                                </td>
                              </>
                            )}
                          </tr>
                        )
                      );
                    })}
                </tbody>
                <tfoot>
                  <tr className="total-tr-table">
                    <td
                      style={dynamic_Table_Colors}
                      width={"7%"}
                      className={`both-bottom-border total-tr-table-th  ${this.props.viewType === "TabView"
                        ? "thead_top_border"
                        : ""
                        }`}
                    >
                      {this.lang("Total")}
                    </td>
                    {/* {(window.localStorage.getItem("partnerId") === "002-sa" ||
                      window.localStorage.getItem("partnerId") === "demo-de" ||
                      window.localStorage.getItem("partnerId") === "demo-au" ||
                      window.localStorage.getItem("partnerId") ===
                        "demo-nl") && (
                      <> */}
                    <td className="empty_row"></td>
                    <td
                      style={dynamic_Table_Colors}
                      width={"7%"}
                      className={`both-bottom-border total-tr-table-th   ${this.props.viewType === "TabView"
                        ? "thead_top_border dark-gray-col"
                        : ""
                        }`}
                    ></td>
                    {universal_scan == '1' ?
                      <>
                        <td className="empty_row"></td>
                        <td
                          style={dynamic_Table_Colors}
                          width={"7%"}
                          className={`both-bottom-border total-tr-table-th   ${this.props.viewType === "TabView"
                            ? "thead_top_border yellow-col"
                            : ""
                            }`}
                        >
                          {Dents && this.totalDamageCounts(Dents)}
                        </td>
                      </>
                      : ''
                    }
                    {/* </>
                    )} */}
                    <td className="empty_row"></td>
                    {(this.state.softwareType === "HailInspectionPlusDamage" ||
                      this.state.softwareType === "CarSoft") && (
                        <>
                          <td style={dynamic_Table_Colors} width={"7%"}>
                            {Dents && this.totalDamages(Dents)}
                          </td>
                        </>
                      )}
                    {is_extra_columns_dentsize_show && (
                      <>
                        <td
                          className="bottom-left-border detail-report-extra-col-td"
                          style={dynamic_Table_Colors}
                          width={"7%"}
                        >
                          {this.getTotalDents10mm()}
                        </td>
                        <td
                          className="detail-report-extra-col-td"
                          style={dynamic_Table_Colors}
                          width={"7%"}
                        >
                          {this.getTotalDents20mm()}
                        </td>
                        <td
                          className="detail-report-extra-col-td"
                          style={dynamic_Table_Colors}
                          width={"7%"}
                        >
                          {this.getTotalDents30mm()}
                        </td>
                        <td
                          className="detail-report-extra-col-td"
                          style={dynamic_Table_Colors}
                          width={"7%"}
                        >
                          {this.getTotalDents40mm()}
                        </td>
                        <td
                          className="detail-report-extra-col-td"
                          style={dynamic_Table_Colors}
                          width={"7%"}
                        >
                          {this.getTotalDents50mm()}
                        </td>
                        <td
                          className="detail-report-extra-col-td"
                          style={dynamic_Table_Colors}
                          width={"7%"}
                        >
                          {this.getTotalDents60mm()}
                        </td>
                        <td
                          className="bottom-right-border detail-report-extra-col-td"
                          style={dynamic_Table_Colors}
                          width={"7%"}
                        >
                          {this.getTotalDents70mm()}
                        </td>
                        {/* <td
                          className="bottom-right-border detail-report-extra-col-td"
                          style={dynamic_Table_Colors}
                          width={"7%"}
                        >
                          {this.getTotalDents80mm()}
                        </td> */}
                        <td className="empty_row"></td>
                      </>
                    )}
                    <td
                      className={`both-bottom-border total-tr-table-th  ${this.props.viewType === "TabView"
                        ? "thead_top_border light-gray-col"
                        : ""
                        }`}
                      style={dynamic_Table_Colors}
                    // className="both-bottom-border"
                    >
                      {Dents &&
                        isNaN(
                          Dents &&
                          Dents.reduce(
                            (acc, num) =>
                              parseInt(acc) +
                              (num.Plastic ? 0 : num.TotalDents),
                            0
                          )
                        )
                        ? 0
                        : Dents &&
                        Dents.reduce(
                          (acc, num) =>
                            parseInt(acc) +
                            (num.Plastic ? 0 : num.TotalDents),
                          0
                        )}
                    </td>
                    <td className="empty_row"></td>
                    <td
                      style={dynamic_Table_Colors}
                      width={"7%"}
                      className={`both-bottom-border total-tr-table-th   ${this.props.viewType === "TabView"
                        ? "thead_top_border yellow-col"
                        : ""
                        }`}
                    >
                      {partnerId === "10-200410-2" || partnerId === "10-200410"
                        ? Dents && isNaN(this.round10(averageDentsSizeTotal, 1))
                          ? 0
                          : (
                            this.round10(averageDentsSizeTotal, 1) * 0.0393701
                          ).toFixed(2)
                        : Dents && isNaN(this.round10(averageDentsSizeTotal, 1))
                          ? 0
                          : this.round10(averageDentsSizeTotal, 1)}
                      {/* {Dents &&
                          isNaN(this.avg(
                            parseInt(
                              Dents.reduce((acc, num) => {
                                return parseInt(acc) + num.AvgDiaMm;
                              }, 0) /
                                Dents.reduce(
                                  (acc, num) => parseInt(acc) + num.TotalDents,
                                  0
                                )
                            )
                          )) ? 0 : this.avg(
                            parseInt(
                              Dents.reduce((acc, num) => {
                                return parseInt(acc) + num.AvgDiaMm;
                              }, 0) /
                                Dents.reduce(
                                  (acc, num) => parseInt(acc) + num.TotalDents,
                                  0
                                )
                            )
                          )} */}
                    </td>
                    <td className="empty_row"></td>
                    <td
                      style={dynamic_Table_Colors}
                      width={"7%"}
                      className={`both-bottom-border total-tr-table-th   ${this.props.viewType === "TabView"
                        ? "thead_top_border orange-col"
                        : ""
                        }`}
                    ></td>
                    <td className="empty_row"></td>
                    <td
                      className={`both-bottom-border total-tr-table-th   ${this.props.viewType === "TabView"
                        ? "thead_top_border green-col"
                        : ""
                        }`}
                      style={dynamic_Table_Colors}
                      width={"7%"}
                    ></td>
                    <td className="empty_row"></td>
                    <td
                      style={dynamic_Table_Colors}
                      width={"7%"}
                      className={`both-bottom-border total-tr-table-th   ${this.props.viewType === "TabView"
                        ? "thead_top_border blue-col"
                        : ""
                        }`}
                    ></td>
                    {/* <td className="empty_row"></td> */}
                    {/* <td></td> */}
                    {this.props.is_extra_columns_visible && (
                      <>
                        <td className="empty_row"></td>
                        <td
                          style={dynamic_Table_Colors}
                          width={"7%"}
                          className={`both-bottom-border ${this.props.viewType === "TabView"
                            ? "thead_top_border dark-gray-col"
                            : ""
                            }`}
                        ></td>
                        <td className="empty_row"></td>
                        <td
                          className={`both-bottom-border ${this.props.viewType === "TabView"
                            ? "thead_top_border green-col"
                            : ""
                            }`}
                          style={dynamic_Table_Colors}
                          width={"7%"}
                        ></td>
                      </>
                    )}

                    {ShowAW && (
                      <>
                        <td className="empty_row"></td>
                        <td
                          style={dynamic_Table_Colors}
                          width={"7%"}
                          className={`both-bottom-border tfoot-bottom-td-text p-0 m-0 ${this.props.viewType === "TabView" ? "german-total-price" : ""
                            }`}
                        >
                          {Dents &&
                            isNaN(
                              parseInt(
                                Dents.reduce(
                                  (acc, num) =>
                                    parseInt(acc) + (num.Plastic ? 0 : num.AW),
                                  0
                                )
                              )
                            )
                            ? 0
                            : parseInt(
                              Dents.reduce(
                                (acc, num) =>
                                  parseInt(acc) + (num.Plastic ? 0 : num.AW),
                                0
                              )
                            )}
                        </td>
                      </>
                    )}

                    {/* {ShowAW &&
                    <>
                      <td className="empty_row"></td>
                      <td 
                        style={dynamic_Table_Colors}
                        width={"7%"}
                        className={`both-bottom-border tfoot-bottom-td-text p-0 m-0 ${this.props.viewType === 'TabView'  ?  "" : "" }`}
                      >
                          {Dents &&
                            isNaN(parseInt(
                              Dents.reduce((acc, num) => parseInt(acc) + num.AW, 0)
                            )) ? 0 : parseInt(
                              Dents.reduce((acc, num) => parseInt(acc) + num.AW, 0)
                            ) }
                      </td>           
                    </>
                    } */}
                    {/* <td style={{ textAlign: "center" }}>
                      <b>
                        {Dents &&
                          parseInt(
                            Dents.reduce((acc, num) => parseInt(acc) + num.AW, 0)
                          )}
                      </b>
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <b>
                        {Dents &&
                          parseInt(
                            Dents.reduce((acc, num) => parseInt(acc) + num.AW, 0)
                          )}
                      </b>
                    </td> */}
                  </tr>
                  <tr>
                    <td className="empty_height"></td>
                  </tr>
                  {<tr className="notes_tr all_notes_tr">
                    <td
                      className="text-left footer-sl-td bottom-left-border"
                      style={dynamic_Table_Colors}
                    >
                      {this.lang("Notes")}
                    </td>
                    <td className="empty_row"></td>
                    <td
                      className="text-left footer-sl-td bottom-right-border"
                      style={dynamic_Table_Colors}
                      colSpan={universal_scan == '1' ? 23 : 21}
                    >
                      {this.props.is_extra_columns_visible ?
                        <input
                          name='UserNotesFooter'
                          disabled={Authorized}
                          type='text'
                          style={{ width: '100%', border: 'none', outline: 'none' }}
                          value={data.UserNotesFooter}
                          onChange={(e) => this.handleNotesChange(e)}
                        />
                        :
                        data.UserNotesFooter
                        //  <>
                        //   <p className="updated-notes-text">

                        //   </p>
                        //  </>
                      }
                    </td>
                  </tr>}
                </tfoot>
              </table>
            </div>
            {modal && (
              <Lightbox
                reactModalStyle={{
                  overlay: { zIndex: 100000000 },
                  content: {},
                }}
                mainSrc={
                  this.state.filteredImages.length > 0
                    ? `${this.state.filteredImages[this.state.currentImageIndex]}?t=${new Date().getTime()}` // Append timestamp
                    : require("../../assets/img/brand/dashboard-error-logo.png")
                }
                imageCaption={this.state.filteredImages.length > 0 && this.lang(
                  this.state.filteredImages[this.state.currentImageIndex]
                    .split('/')
                    .pop()
                    .replace(/^Report_/, '')
                    .replace(/_\d+\.jpg$/, '')
                )}
                nextSrc={
                  `${this.state.filteredImages[
                  (this.state.currentImageIndex + 1) % this.state.filteredImages.length
                  ]}?t=${new Date().getTime()}`
                }
                prevSrc={
                  `${this.state.filteredImages[
                  (this.state.currentImageIndex +
                    this.state.filteredImages.length -
                    1) % this.state.filteredImages.length
                  ]}?t=${new Date().getTime()}`
                }
                onCloseRequest={() => this.setState({ modal: false })}
                onMovePrevRequest={() =>
                  this.setState({
                    currentImageIndex:
                      (this.state.currentImageIndex +
                        this.state.filteredImages.length -
                        1) %
                      this.state.filteredImages.length,
                  })
                }
                onMoveNextRequest={() =>
                  this.setState({
                    currentImageIndex:
                      (this.state.currentImageIndex + 1) %
                      this.state.filteredImages.length,
                  })
                }
                onImageLoadError={(...events) => console.log(events)}
                imageLoadErrorMessage={
                  <img
                    style={{ height: "100%", width: "100%" }}
                    src={require("../../assets/img/brand/dashboard-error-logo.png")}
                  />
                }
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}
const mapDispatchtoProps = (dispatch) => {
  return {
    getSelectedPartnerId: (show) => dispatch(getSelectedPartnerId(show)),
    reportAuthorized: (show) => dispatch(reportAuthorized(show)),
  };
};
const mapStateToProps = (props) => {
  return {
    lang: props.lang,
    toggleReportDamageImage: props.toggleReportDamageImage
  };
};
export default connect(mapStateToProps, mapDispatchtoProps)(DNSPriceTable);
